// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:35:08.013Z
// Property: Villas at Stonebridge (ID: 6767906449165641)
// Collections: 21 amenities, 8 floorplans (live), 42 photos, 73 POIs, 2 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165641",
  "property_external_id": "qtqmd3z",
  "property_zillow_url": "https://www.zillow.com/apartments/edmond-ok/villas-at-stonebridge/5XqjXb",
  "property_apartments_url": "https://www.apartments.com/villas-at-stonebridge-edmond-ok/qtqmd3z/",
  "property_google_business_url": "https://www.google.com/maps/place/Villas+at+Stonebridge/data=!4m2!3m1!1s0x0:0x8db21f34bbe5dd4d?sa=X&ved=2ahUKEwjNu93Qgr2SAxWi4skDHTEpJQ8Q_BJ6BAgUEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "villas-at-stonebridge",
  "property_name": "Villas at Stonebridge",
  "property_website_url": "https://www.caseusa.com/apartments/ok/edmond/villas-at-stonebridge/",
  "property_domain": null,
  "property_address": "157 Stonebridge Blvd.",
  "property_full_address": "157 Stonebridge Blvd., Edmond, OK, 73013",
  "property_address_1": "157 Stonebridge Blvd.",
  "property_address_2": null,
  "property_address_city": "Edmond",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73013",
  "property_address_country": "US",
  "property_address_county": "Oklahoma County",
  "property_neighborhood_address": "Edmond",
  "property_address_latitude": "35.6202",
  "property_address_longitude": "-97.4826",
  "property_email": "stonebridge@caseusa.com",
  "property_phone": "(405) 451-1465",
  "property_call_tracking_phone": "833-510-0226",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Live life elevated at Villas at Stonebridge in Edmond, Oklahoma, where modern living meets comfort. Choose from spacious one to three-bedroom floor plans featuring vaulted ceilings and walk-in closets. Relax by the pool, stay fit in our gym, or unwind in the clubhouse. Your perfect home awaits—schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Villas at Stonebridge, your ultimate living destination in Edmond, Oklahoma! Our thoughtfully designed apartment community features a variety of spacious floor plans, including one, two, and three-bedroom options, ensuring you find the perfect fit for your lifestyle. \n\nAt Villas at Stonebridge, we prioritize your comfort and convenience with an impressive array of amenities. Dive into relaxation at our sparkling pool, or break a sweat in our fully-equipped fitness center. Enjoy social gatherings in our inviting clubhouse or get some work done in our dedicated business center. We offer on-site maintenance and have a property manager available to address your needs. Plus, pet lovers will appreciate our pet play area, making your furry friends feel right at home.\n\nStep outside to explore our beautifully landscaped picnic area, where you can grill with friends or unwind in our cabana. Each apartment comes with essential features like in-unit washers and dryers, air conditioning, granite kitchens, and walk-in closets. Choose between stylish hardwood, tile, or vinyl flooring, and enjoy modern touches like vaulted ceilings and cozy fireplaces. Many units offer private balconies or patios, perfect for enjoying the gorgeous Oklahoma weather.\n\nExperience a gated community that values your peace of mind and lifestyle. With high-speed internet access and smoke-free living, Villas at Stonebridge is the ideal place to call home. \n\nDon’t wait to discover your new life at Villas at Stonebridge! Browse our availability or schedule a tour today to explore our beautiful community and all it has to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-65e8-72dc-a48d-2d2504000832.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
    "public_id": "019cfb4c-65e8-72dc-a48d-2d2504000832",
    "storage_key": "property/6767906449165641/019cfb4c-65e8-72dc-a48d-2d2504000832.webp",
    "width": 1600,
    "height": 1067
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "484",
  "property_year_built": "2005",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.86776859504133",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "150",
  "property_pet_restrictions": "Contact Leasing Office for details.",
  "property_pet_policy_description": "Pets Welcome - Contact Leasing Office for details.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://villasatstonebridgeapartmentsedmond.securecafe.com/onlineleasing/villas-at-stonebridge-i-ii/floorplans.aspx",
  "property_resident_portal_url": "https://villasatstonebridgeapartmentsedmond.securecafe.com/residentservices/villas-at-stonebridge-i-ii/userlogin.aspx",
  "property_apply_now_url": "https://villasatstonebridgeapartmentsedmond.securecafe.com/onlineleasing/villas-at-stonebridge-i-ii/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-5c5e-73cd-a32f-096698630609.webp",
  "property_primary_logo_media": {
    "alt_text": "Villas at Stonebridge Apartments logo",
    "public_id": "019cfb4c-5c5e-73cd-a32f-096698630609",
    "storage_key": "property/6767906449165641/019cfb4c-5c5e-73cd-a32f-096698630609.webp",
    "width": 1081,
    "height": 315
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-ceb4-745d-8811-a1ff1f197405.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb4d-ceb4-745d-8811-a1ff1f197405",
    "storage_key": "property/6767906449165641/019cfb4d-ceb4-745d-8811-a1ff1f197405.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-dab9-758f-8115-694b4e8e8cb0.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Villas at Stonebridge Apartments logo.",
    "public_id": "019cfb4d-dab9-758f-8115-694b4e8e8cb0",
    "storage_key": "property/6767906449165641/019cfb4d-dab9-758f-8115-694b4e8e8cb0.webp",
    "width": 640,
    "height": 186
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-e2ca-72af-99c2-409f229db7ed.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Villas at Stonebridge Apartments logo",
    "public_id": "019cfb4d-e2ca-72af-99c2-409f229db7ed",
    "storage_key": "property/6767906449165641/019cfb4d-e2ca-72af-99c2-409f229db7ed.webp",
    "width": 640,
    "height": 186
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#845950",
  "property_secondary_color": "#374548",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1178",
  "property_sqft_min": "789",
  "property_sqft_max": "1178",
  "property_price_range": "1109 - 1669",
  "property_price_min": "1109",
  "property_price_max": "1669",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/VillasStonebridge/posts/every-journey-to-a-new-home-is-an-adventure-at-villas-at-stonebridge-were-here-t/1486477513485228/",
  "property_instagram_url": "https://www.instagram.com/villasstonebridge/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJv7Uk0E0fsocRTd3luzQfso0",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Oklahoma+County%2C+OK",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Villas at Stonebridge",
  "property_home_romance_title": "Embrace Your New Home and Build Lasting Memories Here",
  "property_home_amenities_blurb": "Welcome to Villas at Stonebridge, where comfort meets convenience in the heart of Edmond, Oklahoma. Choose from stylish one, two, or three-bedroom layouts, each offering modern amenities like a refreshing pool, state-of-the-art fitness center, and inviting clubhouse. Experience the perfect blend of relaxation and lifestyle. Your new home awaits!",
  "property_home_floorplans_blurb": "Welcome to Villas at Stonebridge in charming Edmond, Oklahoma, where modern living meets comfort. Whether you’re seeking a cozy one-bedroom or a spacious three-bedroom, our diverse floor plans cater to every lifestyle. Browse our available apartment homes to uncover the ideal space that truly feels like home.",
  "property_home_gallery_blurb": "At Villas at Stonebridge in Edmond, Oklahoma, your dream home awaits! Choose from spacious one, two, or three-bedroom floor plans, and indulge in premier amenities, including a refreshing pool, state-of-the-art fitness center, and serene picnic area. Picture yourself living here, where comfort and community come together harmoniously.",
  "property_home_neighborhood_blurb": "Welcome to Villas at Stonebridge in Edmond, Oklahoma, where comfort meets adventure. Immerse yourself in the vibrant neighborhood, featuring family-friendly attractions like the Blue Zoo Aquarium and national treasures like the National Cowboy & Western Heritage Museum. Embrace a lifestyle enriched by parks, exciting events, and top-notch educational institutions.",
  "property_home_reviews_blurb": "At Villas at Stonebridge in Edmond, Oklahoma, residents enjoy a stylish and welcoming atmosphere that feels like home. With a 5-star rating, one resident praised the \"great location—close to everything but still quiet and safe,\" highlighting our responsive team led by Chad. Experience a community that prioritizes comfort and convenience!",
  "property_neighborhood_blurb": "Nestled in the heart of Edmond, Villas at Stonebridge offers easy access to a vibrant neighborhood filled with excitement. Enjoy outdoor adventures at E.C. Hafer Park, explore the wonders of Blue Zoo Aquarium, or dive into local culture at the National Cowboy & Western Heritage Museum. See what’s around our community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Villas at Stonebridge in Edmond, Oklahoma, comfort meets convenience with our diverse floor plans—one, two, and three-bedroom options to suit your lifestyle. Enjoy resort-style amenities like a sparkling pool, fitness center, and serene picnic areas, all designed for relaxation and connection. Experience your perfect sanctuary today!",
  "property_applynow_blurb": "Elevate your lifestyle at Villas at Stonebridge in Edmond, Oklahoma, where spacious one, two, and three-bedroom floor plans seamlessly blend comfort and luxury. Enjoy resort-style amenities like a sparkling pool, fitness center, and inviting clubhouse. Lease online today and step into the vibrant community you deserve!",
  "property_contactus_blurb": "At Villas at Stonebridge in Edmond, Oklahoma, our thoughtfully designed floor plans cater to every lifestyle, featuring spacious one, two, and three-bedroom apartments. Each home radiates comfort and style, perfect for your next chapter. Have questions? Contact our leasing team today and start your journey to upscale living!",
  "property_faqs_blurb": "At Villas at Stonebridge in Edmond, Oklahoma, we cater to every lifestyle with our thoughtfully designed one, two, and three-bedroom floor plans. Have questions? Our FAQs page offers insightful answers to help you navigate your future home. Your journey to comfortable living begins here!",
  "property_floorplans_blurb": "At Villas at Stonebridge in Edmond, Oklahoma, our thoughtfully designed floor plans offer comfort and style for every lifestyle. Whether you need a cozy one-bedroom, spacious two-bedroom, or expansive three-bedroom, you’ll find the ideal space to call home. Browse our available apartment homes and embark on your new journey!",
  "property_gallery_blurb": "At Villas at Stonebridge in Edmond, Oklahoma, your ideal home awaits amidst stunning amenities and diverse floor plans. Enjoy sunny days by the pool, invigorate at the fitness center, or unwind on your private balcony. Picture yourself living here, where comfort and community come together to create your perfect retreat.",
  "property_interactivemap_blurb": "At Villas at Stonebridge in Edmond, Oklahoma, choose from spacious one, two, or three-bedroom apartments designed for modern living. Enjoy resort-style amenities like a refreshing pool, fitness center, and inviting clubhouse. Use our interactive community map to explore available homes and find your perfect oasis today!",
  "property_pets_blurb": "Welcome to Villas at Stonebridge in Edmond, OK, where modern living meets comfort. Nestled among scenic landscapes, our vibrant community invites you to unwind with your furry friends. Enjoy spacious apartments and a wealth of amenities tailored to elevate your lifestyle. Contact our leasing office to learn more about our pet policy today!",
  "property_referafriend_blurb": "At Villas at Stonebridge in Edmond, Oklahoma, we believe great friends make the best neighbors! With spacious one, two, and three-bedroom floor plans, you’ll find the perfect home to share life’s moments. Refer a friend today and build a vibrant community where friendships flourish! ",
  "property_residentaccess_blurb": "Welcome to the Villas at Stonebridge in Edmond, Oklahoma, where comfort meets style. Choose from our thoughtfully designed one, two, or three-bedroom floor plans that fit your lifestyle. Access your resident portal to effortlessly pay rent, schedule maintenance, and stay connected with your community!",
  "property_reviews_blurb": "At Villas at Stonebridge in Edmond, Oklahoma, residents rave about the bright, stylish apartments and attentive staff. One resident highlights, “Chad is very kind and does a great job being professional,” emphasizing our commitment to a hassle-free living experience. Experience comfort and tranquility—your perfect home awaits!",
  "property_created_at": "1753982396789",
  "property_scheduletour_blurb": "At Villas at Stonebridge in Edmond, Oklahoma, discover a perfect blend of comfort and style with our thoughtfully designed one, two, and three-bedroom floor plans. Schedule a tour today and see what our residents love about their vibrant community living experience!",
  "property_thankyou_blurb": "Thank you for reaching out to Villas at Stonebridge in Edmond, Oklahoma! Our diverse floor plans, ranging from one to three bedrooms, cater to every lifestyle. A team member will connect with you soon, ready to guide you towards your next home sweet home. Stay tuned!",
  "property_virtualtours_blurb": "Welcome to Villas at Stonebridge in Edmond, Oklahoma, where modern living meets comfort. Choose from our thoughtfully designed one, two, or three-bedroom floor plans tailored to your lifestyle. Take a virtual tour today and envision your new home in our vibrant community, where every detail is crafted for you!",
  "property_copyright": "2025 All Rights Reserved. Villas at Stonebridge",
  "property_seo_title_home": "Villas at Stonebridge |  Apartments in Edmond, Oklahoma",
  "property_seo_description_home": "Experience luxury at Villas at Stonebridge in Edmond, OK! Spacious floor plans and resort-style amenities await. Join our welcoming community today!",
  "property_seo_title_floorplans": "Floor Plans | Edmond, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Villas at Stonebridge in Edmond, OK! From cozy one-bedrooms to spacious three-bedrooms, browse our unique floor plans today!",
  "property_seo_title_amenities": "Amenities | Edmond, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience unmatched comfort at Villas at Stonebridge in Edmond, OK. With pools, fitness centers, and pet-friendly spaces, your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Edmond, Oklahoma",
  "property_seo_description_gallery": "Discover the charm of Villas at Stonebridge in Edmond, OK—stunning floor plans and top amenities await in our vibrant community!",
  "property_seo_title_virtualtours": "Virtual Tours | Villas at Stonebridge Apartments",
  "property_seo_description_virtualtours": "Experience upscale living at Villas at Stonebridge in Edmond, OK. Dive into our one, two, or three-bedroom apartments—take a virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Villas at Stonebridge Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Villas at Stonebridge in Edmond, OK! Check our interactive map for one-, two-, and three-bedroom apartments with luxury amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Edmond, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the charm of Edmond, Oklahoma! At Villas at Stonebridge, find local favorites and hidden gems waiting just beyond your doorstep. Visit us today!",
  "property_seo_title_contact": "Contact Us | Villas at Stonebridge",
  "property_seo_description_contact": "Get in touch with Villas at Stonebridge in Edmond, Oklahoma! Our leasing team is ready to answer your questions about our one, two, and three-bedroom plans!",
  "property_seo_title_faqs": "FAQs | Apartments in Edmond, Oklahoma",
  "property_seo_description_faqs": "Find answers to your burning questions about Villas at Stonebridge in Edmond! From amenities to floor plans, everything you need is just a click away.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Edmond, Oklahoma",
  "property_seo_description_reviews": "Join the Villas at Stonebridge community in Edmond, OK! Enjoy pools, fitness, and more. See what our residents love about their vibrant home today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Edmond, Oklahoma",
  "property_seo_description_applynow": "Find your perfect home at Villas at Stonebridge in Edmond, OK. Enjoy spacious layouts, top-notch amenities, and a welcoming community. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Villas at Stonebridge",
  "property_seo_description_residentaccess": "Welcome to your home at Villas at Stonebridge in Edmond! Log in to access your portal for easy rent payment, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Villas at Stonebridge",
  "property_seo_description_referafriend": "Refer a friend to Villas at Stonebridge in Edmond! Great friends make great neighbors—share the joy of community living today and enjoy exclusive rewards!",
  "property_seo_title_scheduletour": "Schedule a Tour | Villas at Stonebridge",
  "property_seo_description_scheduletour": "Experience the charm of Villas at Stonebridge in Edmond, OK. Schedule your tour today and find your perfect home in a vibrant community that welcomes you!",
  "property_seo_title_privacy": "Privacy Policy | Villas at Stonebridge",
  "property_seo_description_privacy": "Discover how Villas at Stonebridge in Edmond, OK, protects your privacy while you enjoy our vibrant community. View our policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Villas at Stonebridge",
  "property_seo_description_accessibility": "Discover inclusive living at Villas at Stonebridge, Edmond, OK. We prioritize accessibility for all residents. Join our community today!",
  "property_seo_title_sitemap": "Sitemap | Villas at Stonebridge",
  "property_seo_description_sitemap": "Navigate the Villas at Stonebridge in Edmond, OK. Find your perfect home effortlessly with our easy-to-use sitemap. Your dream apartment awaits!",
  "property_seo_title_thankyou": "Thank You | Villas at Stonebridge",
  "property_seo_description_thankyou": "Thank you for reaching out to Villas at Stonebridge! A team member will connect with you soon to discuss your future home in beautiful Edmond, OK.",
  "property_seo_title_pets": "Pet Policy | Apartments in Edmond, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787866097725",
  "amenities": [
    {
      "id": "ec_151de64c022e6865924a0a3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127397408",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bbb8f4fff1da643d4bdcb09a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127397410",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2661f23e62267303cd8438c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127397412",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e831e2109aad63fb049cdd9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127397413",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8bbc0c81ae8db3f7512ee3fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127397414",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e56cbe5b79203e5604d6baa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127397415",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ce7b5bb28643286b0798fe8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127397416",
      "title": "Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9348bc09449c4bd34b9fb82b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127397417",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e2214a3c3e4665fa06d3a5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127397418",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_457dc7f81b3060b161b7d00f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127397419",
      "title": "Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc87de7287e75597d2021819",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "128042560",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_12d39a5c31631fef9dc6b259",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "128017297",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa5f2d8126a5e6bdf56c710b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127398867",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1af751d33d1ab2a7d6bb7f42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127398868",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e8b485e633151ab113c5650b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127398869",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_895e4a17862d21f512d361fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127398870",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff2ec5749359d4efbda17548",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127398871",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd0894573d38b33c0dea442c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127398872",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51801995491e5d547ecfa02c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127398873",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1d882249de28ef1dd4eb0f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127398874",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7af0fbe559660b60d3e60480",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "yardi",
      "external_id": "127398875",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_0d8d9220-0d6f-4cea-b5b5-1acb3f6c71ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-49db-709b-8b61-2adb77fb7770.webp",
      "image_media": {
        "alt_text": "Stone entrance sign for Villages of Stonebridge with stone pillars and flowering plants.",
        "public_id": "019d20b0-49db-709b-8b61-2adb77fb7770",
        "storage_key": "property/6767906449165641/019d20b0-49db-709b-8b61-2adb77fb7770.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Entrance sign and landscaped entry to the Villages of Stonebridge community.",
      "link": "",
      "alt_text": "Stone entrance sign for Villages of Stonebridge with stone pillars and flowering plants.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-0b7e-7339-b6a2-bb7301a95a23.webp"
    },
    {
      "id": "custom_ec5f4baf-6e45-4342-a917-d35d095b4dff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-4a33-73f9-b7ff-b375c3cef811.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment community with a landscaped walkway and colorful flowers.",
        "public_id": "019d20b0-4a33-73f9-b7ff-b375c3cef811",
        "storage_key": "property/6767906449165641/019d20b0-4a33-73f9-b7ff-b375c3cef811.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of a well-maintained apartment community entrance with brick architecture, arched doorway, and lush landscaping.",
      "link": "",
      "alt_text": "Exterior view of a brick apartment community with a landscaped walkway and colorful flowers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-1735-721e-bc8c-80810a043583.webp"
    },
    {
      "id": "custom_25e96b69-75fc-4117-8e83-0e056056cfbf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-4a58-71a8-9cd8-bbe34b1ca176.webp",
      "image_media": {
        "alt_text": "Front entrance of a beige apartment building with tall columns and landscaping.",
        "public_id": "019d20b0-4a58-71a8-9cd8-bbe34b1ca176",
        "storage_key": "property/6767906449165641/019d20b0-4a58-71a8-9cd8-bbe34b1ca176.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of the apartment community’s main entrance with columns, landscaping, and signage.",
      "link": "",
      "alt_text": "Front entrance of a beige apartment building with tall columns and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-1d67-730c-873e-24cbd124cda7.webp"
    },
    {
      "id": "custom_607503d9-9f24-41c4-ac6b-cf63230f656e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-49e0-76bf-9010-ce3f85128d52.webp",
      "image_media": {
        "alt_text": "Exterior view of a beige multi-family building with balconies and a green lawn.",
        "public_id": "019d20b0-49e0-76bf-9010-ce3f85128d52",
        "storage_key": "property/6767906449165641/019d20b0-49e0-76bf-9010-ce3f85128d52.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior of a modern apartment community with multiple balconies, stone accents, and a spacious green lawn.",
      "link": "",
      "alt_text": "Exterior view of a beige multi-family building with balconies and a green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-23ee-766f-8075-c11cd1472ef7.webp"
    },
    {
      "id": "custom_abf874d1-47a6-4405-972c-beeeb96c7c4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-53cb-740e-a7b8-ce6e0e2e4719.webp",
      "image_media": {
        "alt_text": "Fenced grassy community playground with a slide, seesaw, and climbing toys.",
        "public_id": "019d20b0-53cb-740e-a7b8-ce6e0e2e4719",
        "storage_key": "property/6767906449165641/019d20b0-53cb-740e-a7b8-ce6e0e2e4719.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Sunny community yard with a children's playground and open green space.",
      "link": "",
      "alt_text": "Fenced grassy community playground with a slide, seesaw, and climbing toys.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-2f6c-7526-a061-67e0518c9519.webp"
    },
    {
      "id": "custom_a9d01070-b8d7-4f4f-bc9b-157ffe9fb7a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-54c3-761e-ba25-80cb52c46300.webp",
      "image_media": {
        "alt_text": "Pond with fountains, grassy park, and a bench along a walkway with apartment buildings in the distance.",
        "public_id": "019d20b0-54c3-761e-ba25-80cb52c46300",
        "storage_key": "property/6767906449165641/019d20b0-54c3-761e-ba25-80cb52c46300.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Scenic community pond with fountains, green space, and nearby apartment buildings.",
      "link": "",
      "alt_text": "Pond with fountains, grassy park, and a bench along a walkway with apartment buildings in the distance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4b-f47f-705c-aa50-ca99ddc6347b.webp"
    },
    {
      "id": "custom_dbecb9ef-d3f1-4f6c-a7e9-e29d74064fac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-56d6-70c8-b8df-4f5ca2acb774.webp",
      "image_media": {
        "alt_text": "Outdoor community pool with blue lounge chairs and a clubhouse-style building in the background.",
        "public_id": "019d20b0-56d6-70c8-b8df-4f5ca2acb774",
        "storage_key": "property/6767906449165641/019d20b0-56d6-70c8-b8df-4f5ca2acb774.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Outdoor pool at the community with ample seating and a clubhouse-style building in the background.",
      "link": "",
      "alt_text": "Outdoor community pool with blue lounge chairs and a clubhouse-style building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165641/019cfb4c-65e8-72dc-a48d-2d2504000832.webp"
    },
    {
      "id": "custom_c8983198-9c0d-442d-a0a9-59adccda2d4e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-56cc-756a-ae41-8c6e6367449f.webp",
      "image_media": {
        "alt_text": "Outdoor community grilling area with stone grills, tables, benches, and umbrellas.",
        "public_id": "019d20b0-56cc-756a-ae41-8c6e6367449f",
        "storage_key": "property/6767906449165641/019d20b0-56cc-756a-ae41-8c6e6367449f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Outdoor community grilling and seating area at a multifamily property, featuring stone grills, round tables, benches, and shade umbrellas.",
      "link": "",
      "alt_text": "Outdoor community grilling area with stone grills, tables, benches, and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-0f52-763a-a959-1b6113953cce.webp"
    },
    {
      "id": "custom_2be7bb9e-a097-4b83-98b1-66f3d25c1d7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-5d50-764b-a68b-a034407eaa0e.webp",
      "image_media": {
        "alt_text": "Lobby-style communal lounge with two teal sofas, a stone fireplace, and a mounted TV.",
        "public_id": "019d20b0-5d50-764b-a68b-a034407eaa0e",
        "storage_key": "property/6767906449165641/019d20b0-5d50-764b-a68b-a034407eaa0e.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Spacious community lounge in the leasing lobby featuring a stone fireplace, modern seating, and a large TV.",
      "link": "",
      "alt_text": "Lobby-style communal lounge with two teal sofas, a stone fireplace, and a mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165641/019cfb4c-6599-72d3-92a3-0a9c9a27503a.webp"
    },
    {
      "id": "custom_a32809a9-ca67-49f5-991a-be58c070172c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-6124-7613-890f-160411f64ce0.webp",
      "image_media": {
        "alt_text": "Spacious modern resident lounge with a stone fireplace, teal sofas, and large windows.",
        "public_id": "019d20b0-6124-7613-890f-160411f64ce0",
        "storage_key": "property/6767906449165641/019d20b0-6124-7613-890f-160411f64ce0.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Bright, open community lounge with a stone fireplace, comfortable seating, and expansive windows in a contemporary clubhouse.",
      "link": "",
      "alt_text": "Spacious modern resident lounge with a stone fireplace, teal sofas, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4b-f46f-73a8-8286-8b24a881462f.webp"
    },
    {
      "id": "custom_d23ec3be-a9c8-4065-bc70-86a7d4dacb46",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-615e-71cb-8236-bd87612efd67.webp",
      "image_media": {
        "alt_text": "Interior of a resident business center with two computer stations and a printer.",
        "public_id": "019d20b0-615e-71cb-8236-bd87612efd67",
        "storage_key": "property/6767906449165641/019d20b0-615e-71cb-8236-bd87612efd67.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Modern resident business center with two computer stations, a printer, and seating for work.",
      "link": "",
      "alt_text": "Interior of a resident business center with two computer stations and a printer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4b-f6d7-70bd-ab6d-2cfc40977537.webp"
    },
    {
      "id": "custom_370a99b3-b0f6-421a-b3bb-f81695929a10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-62ee-724c-a945-81ef02d5b4cf.webp",
      "image_media": {
        "alt_text": "Well-equipped apartment community gym with treadmills and strength machines.",
        "public_id": "019d20b0-62ee-724c-a945-81ef02d5b4cf",
        "storage_key": "property/6767906449165641/019d20b0-62ee-724c-a945-81ef02d5b4cf.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Fitness center at the property featuring cardio machines, weight equipment, and modern flooring.",
      "link": "",
      "alt_text": "Well-equipped apartment community gym with treadmills and strength machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-3210-7747-9353-c956f6575d9d.webp"
    },
    {
      "id": "custom_e55d9630-c6ef-4276-bbf6-72a7b5b33319",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-6654-731c-8728-4c7a6c3f2784.webp",
      "image_media": {
        "alt_text": "Bright on-site gym with treadmills, free weights, and strength machines.",
        "public_id": "019d20b0-6654-731c-8728-4c7a6c3f2784",
        "storage_key": "property/6767906449165641/019d20b0-6654-731c-8728-4c7a6c3f2784.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Modern on-site fitness center for residents, featuring cardio machines, free weights, and weight machines.",
      "link": "",
      "alt_text": "Bright on-site gym with treadmills, free weights, and strength machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165641/019cfb4c-647f-7037-b46f-b2afa42e3e77.webp"
    },
    {
      "id": "custom_3bbea82b-4e54-429a-87af-7527421e9f6e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-6b4f-7018-90a4-7cdce169859c.webp",
      "image_media": {
        "alt_text": "Bedroom with dark wood bed frame, matching nightstand and dresser, neutral walls and carpet.",
        "public_id": "019d20b0-6b4f-7018-90a4-7cdce169859c",
        "storage_key": "property/6767906449165641/019d20b0-6b4f-7018-90a4-7cdce169859c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Contemporary apartment bedroom with dark wood furniture and plush carpeting.",
      "link": "",
      "alt_text": "Bedroom with dark wood bed frame, matching nightstand and dresser, neutral walls and carpet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4b-f45a-706c-8c0a-badffbf413d8.webp"
    },
    {
      "id": "custom_54a8800d-fae9-4813-8325-22470abca9ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-6b78-700a-b128-d8e06b2cacd5.webp",
      "image_media": {
        "alt_text": "Furnished bedroom with a dark wood bed, matching nightstands, and a dresser.",
        "public_id": "019d20b0-6b78-700a-b128-d8e06b2cacd5",
        "storage_key": "property/6767906449165641/019d20b0-6b78-700a-b128-d8e06b2cacd5.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with a dark wood bed, nightstands, and dresser, plus patterned bedding and a window with curtains.",
      "link": "",
      "alt_text": "Furnished bedroom with a dark wood bed, matching nightstands, and a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4b-f48b-704f-a911-044b83aaf298.webp"
    },
    {
      "id": "custom_209bea57-427e-483c-a92c-02e251e07389",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-7473-766f-ba19-37f9b3da7a71.webp",
      "image_media": {
        "alt_text": "Living room with beige sofa, rustic coffee table, fireplace, and large windows.",
        "public_id": "019d20b0-7473-766f-ba19-37f9b3da7a71",
        "storage_key": "property/6767906449165641/019d20b0-7473-766f-ba19-37f9b3da7a71.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright living area in a modern apartment with a fireplace, warm neutrals, and stylish furnishings.",
      "link": "",
      "alt_text": "Living room with beige sofa, rustic coffee table, fireplace, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4b-fb21-7448-a138-796fc34e8b22.webp"
    },
    {
      "id": "custom_9061f7dd-e374-4d5a-b4f7-085164ada629",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-747b-7499-bbb3-7aa797fe4d26.webp",
      "image_media": {
        "alt_text": "Corner kitchen in an apartment with white appliances, wood-framed cabinets, and beige countertops.",
        "public_id": "019d20b0-747b-7499-bbb3-7aa797fe4d26",
        "storage_key": "property/6767906449165641/019d20b0-747b-7499-bbb3-7aa797fe4d26.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment kitchen with white appliances, wood-trim cabinets, and light tile flooring.",
      "link": "",
      "alt_text": "Corner kitchen in an apartment with white appliances, wood-framed cabinets, and beige countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-0f16-7329-8b5c-3e030298930d.webp"
    },
    {
      "id": "custom_bd1e94bc-b3e1-404e-915a-f27e7f07f369",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-755b-7159-8866-30375722de04.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a beige sofa, plaid armchair, glass coffee table, and a dining area.",
        "public_id": "019d20b0-755b-7159-8866-30375722de04",
        "storage_key": "property/6767906449165641/019d20b0-755b-7159-8866-30375722de04.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Open-concept living area with seating and a dining space, visible kitchen, in a neutral-toned apartment.",
      "link": "",
      "alt_text": "Living room in an apartment with a beige sofa, plaid armchair, glass coffee table, and a dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4b-f6df-7097-8ef1-57b07758968a.webp"
    },
    {
      "id": "custom_b055d868-f122-4779-b675-ac3106f3f95a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-77ce-72c9-8072-b94abb58df43.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, vanity, mirror, and a tiled shower-tub, plus a decorative rug.",
        "public_id": "019d20b0-77ce-72c9-8072-b94abb58df43",
        "storage_key": "property/6767906449165641/019d20b0-77ce-72c9-8072-b94abb58df43.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with a single vanity, mirror, toilet, and tiled shower/tub.",
      "link": "",
      "alt_text": "Bathroom with toilet, vanity, mirror, and a tiled shower-tub, plus a decorative rug.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-0301-712d-a4a8-46496d30feef.webp"
    },
    {
      "id": "custom_fc61da4b-115a-4111-ae98-7801e2d90081",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-7df5-75cc-a194-d471d1f68eab.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen bed, nightstands, lamp, and two windows with white curtains.",
        "public_id": "019d20b0-7df5-75cc-a194-d471d1f68eab",
        "storage_key": "property/6767906449165641/019d20b0-7df5-75cc-a194-d471d1f68eab.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright, cozy apartment bedroom with a neutral palette, comfortable bedding, and abundant natural light.",
      "link": "",
      "alt_text": "Bedroom with a queen bed, nightstands, lamp, and two windows with white curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-0662-740e-9543-65349eb4ff59.webp"
    },
    {
      "id": "custom_864b20cf-7d1f-44dc-b57f-e2cd88378af4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-7f94-7556-b798-24af9dbe6a8a.webp",
      "image_media": {
        "alt_text": "Bedroom with a dark wood bed and matching dresser with a mirror, beige walls, and two windows with patterned curtains.",
        "public_id": "019d20b0-7f94-7556-b798-24af9dbe6a8a",
        "storage_key": "property/6767906449165641/019d20b0-7f94-7556-b798-24af9dbe6a8a.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious apartment bedroom featuring a dark wood bed frame and matching dresser with a mirror, neutral tones, and natural light from two windows.",
      "link": "",
      "alt_text": "Bedroom with a dark wood bed and matching dresser with a mirror, beige walls, and two windows with patterned curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-0f4a-7097-ad14-5bc2f65cec5d.webp"
    },
    {
      "id": "custom_2541de66-5204-4880-813b-905ad5753dd6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-8088-70a8-87f4-cc2430249754.webp",
      "image_media": {
        "alt_text": "Dining area with a light wood table and white chairs near a sliding glass door leading to a balcony.",
        "public_id": "019d20b0-8088-70a8-87f4-cc2430249754",
        "storage_key": "property/6767906449165641/019d20b0-8088-70a8-87f4-cc2430249754.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright dining nook in a modern apartment with balcony access, neutral tones, and contemporary wall art.",
      "link": "",
      "alt_text": "Dining area with a light wood table and white chairs near a sliding glass door leading to a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-16ff-736f-aee0-76e70253d471.webp"
    },
    {
      "id": "custom_217004ad-c63e-4a89-a798-1b15ed3f82a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-896e-7089-90bc-52894858fb11.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a stone fireplace, beige sofa, armchair, and glass coffee table.",
        "public_id": "019d20b0-896e-7089-90bc-52894858fb11",
        "storage_key": "property/6767906449165641/019d20b0-896e-7089-90bc-52894858fb11.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy living area with a gas fireplace, neutral furnishings, and warm lighting in a stylish apartment.",
      "link": "",
      "alt_text": "Living room in an apartment with a stone fireplace, beige sofa, armchair, and glass coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-1b26-727a-a430-35000e3d4437.webp"
    },
    {
      "id": "custom_7dca95e8-1293-4119-ade6-2adb846ac498",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-8a40-718a-bf14-3ed20397cbd7.webp",
      "image_media": {
        "alt_text": "Dining area with a wooden table and beige upholstered chairs in a bright apartment.",
        "public_id": "019d20b0-8a40-718a-bf14-3ed20397cbd7",
        "storage_key": "property/6767906449165641/019d20b0-8a40-718a-bf14-3ed20397cbd7.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright dining area in an apartment featuring a wooden table, beige upholstered chairs, and a balcony door.",
      "link": "",
      "alt_text": "Dining area with a wooden table and beige upholstered chairs in a bright apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-1aaa-767a-a429-bd7d45605ce8.webp"
    },
    {
      "id": "custom_d944c485-8f23-4463-9a29-ced89dfaee2d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-8ae2-76cf-9a52-b96656f083dd.webp",
      "image_media": {
        "alt_text": "Living room with a brown sofa, wooden coffee table, and a kitchen pass-through with bar stools.",
        "public_id": "019d20b0-8ae2-76cf-9a52-b96656f083dd",
        "storage_key": "property/6767906449165641/019d20b0-8ae2-76cf-9a52-b96656f083dd.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living area in a modern apartment featuring a cozy seating arrangement, warm tones, and a kitchen pass-through.",
      "link": "",
      "alt_text": "Living room with a brown sofa, wooden coffee table, and a kitchen pass-through with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-1d86-701a-8c1f-ef7269bc3e8b.webp"
    },
    {
      "id": "custom_28010e6a-1853-43bd-aaa7-79cb12fd29c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-90a2-713d-9ef7-c4a5dae4203c.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a beige sofa, patterned armchair, round coffee table, and a dining area.",
        "public_id": "019d20b0-90a2-713d-9ef7-c4a5dae4203c",
        "storage_key": "property/6767906449165641/019d20b0-90a2-713d-9ef7-c4a5dae4203c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious apartment living room with neutral decor, comfortable seating, and a dining area.",
      "link": "",
      "alt_text": "Living room in an apartment with a beige sofa, patterned armchair, round coffee table, and a dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-29a0-710d-9c06-482f10247917.webp"
    },
    {
      "id": "custom_8b3bb4a6-60e7-4621-8917-83fdc270fff0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-9651-70ef-9df5-d84efc76320c.webp",
      "image_media": {
        "alt_text": "Bathroom with wooden vanity, sink, toilet, and a tub/shower with a striped curtain.",
        "public_id": "019d20b0-9651-70ef-9df5-d84efc76320c",
        "storage_key": "property/6767906449165641/019d20b0-9651-70ef-9df5-d84efc76320c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom featuring a wooden vanity, mirror, toilet, and tub/shower combo.",
      "link": "",
      "alt_text": "Bathroom with wooden vanity, sink, toilet, and a tub/shower with a striped curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-1d86-701a-8c1f-eacc045ce105.webp"
    },
    {
      "id": "custom_60191118-d06c-4266-80e0-4a253fb6dbad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-964f-7425-9ae1-8811397a473e.webp",
      "image_media": {
        "alt_text": "Bathroom in an apartment with a wooden vanity, mirror, toilet, tub, and purple towels.",
        "public_id": "019d20b0-964f-7425-9ae1-8811397a473e",
        "storage_key": "property/6767906449165641/019d20b0-964f-7425-9ae1-8811397a473e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A clean apartment bathroom with a wooden vanity, large mirror, toilet, and a white tub with a striped shower curtain.",
      "link": "",
      "alt_text": "Bathroom in an apartment with a wooden vanity, mirror, toilet, tub, and purple towels.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-1d5b-7238-ba39-7616441f1f5d.webp"
    },
    {
      "id": "custom_0509868f-c103-4452-9d6d-8d409f630678",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-9a12-734d-b7c9-ba1fb2783982.webp",
      "image_media": {
        "alt_text": "Dining area with a wooden table and four upholstered chairs in a carpeted apartment.",
        "public_id": "019d20b0-9a12-734d-b7c9-ba1fb2783982",
        "storage_key": "property/6767906449165641/019d20b0-9a12-734d-b7c9-ba1fb2783982.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy dining space in a carpeted apartment featuring a wooden table, four chairs, and wall art.",
      "link": "",
      "alt_text": "Dining area with a wooden table and four upholstered chairs in a carpeted apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-2c58-7127-bf65-8435be8d1d0d.webp"
    },
    {
      "id": "custom_a8e6e059-4434-4d18-a96c-c16c340db523",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-9d6d-75d9-affb-782dc3bb045d.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a beige sofa, armchair, and round wooden coffee table.",
        "public_id": "019d20b0-9d6d-75d9-affb-782dc3bb045d",
        "storage_key": "property/6767906449165641/019d20b0-9d6d-75d9-affb-782dc3bb045d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living area with neutral decor, open dining space, and kitchen pass-through.",
      "link": "",
      "alt_text": "Living room in an apartment with a beige sofa, armchair, and round wooden coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-2edd-71a1-9d51-e9ededd6b8ed.webp"
    },
    {
      "id": "custom_20407f6a-55d1-4624-aacc-78a4e997f4bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-a3ba-77fc-924f-9e646a09ce09.webp",
      "image_media": {
        "alt_text": "Bedroom with a dark upholstered bed, patterned pillows, two windows with curtains, and a ceiling fan.",
        "public_id": "019d20b0-a3ba-77fc-924f-9e646a09ce09",
        "storage_key": "property/6767906449165641/019d20b0-a3ba-77fc-924f-9e646a09ce09.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy bedroom in a modern apartment with a plush bed, neutral decor, and ample natural light.",
      "link": "",
      "alt_text": "Bedroom with a dark upholstered bed, patterned pillows, two windows with curtains, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-2caf-754e-873f-37535ae6c15d.webp"
    },
    {
      "id": "custom_d02457a0-d093-485b-82bf-9818f3600de5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-a486-75d9-b72c-805ea735c946.webp",
      "image_media": {
        "alt_text": "U-shaped kitchen with white appliances, wood cabinets, and beige countertops.",
        "public_id": "019d20b0-a486-75d9-b72c-805ea735c946",
        "storage_key": "property/6767906449165641/019d20b0-a486-75d9-b72c-805ea735c946.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen with white appliances, wood cabinets, and a pass-through to the living area.",
      "link": "",
      "alt_text": "U-shaped kitchen with white appliances, wood cabinets, and beige countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-319a-73d4-b704-5f8cf999e004.webp"
    },
    {
      "id": "custom_0c7fc204-566c-4946-819b-ce09905b95db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-a650-720c-8a59-f1d0a2705329.webp",
      "image_media": {
        "alt_text": "Bathroom in an apartment featuring a bathtub with shower curtain, toilet, and wooden vanity with white panels.",
        "public_id": "019d20b0-a650-720c-8a59-f1d0a2705329",
        "storage_key": "property/6767906449165641/019d20b0-a650-720c-8a59-f1d0a2705329.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A clean, modern apartment bathroom with tile flooring, a single vanity, and a tub/shower combo.",
      "link": "",
      "alt_text": "Bathroom in an apartment featuring a bathtub with shower curtain, toilet, and wooden vanity with white panels.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-3865-72b7-a4d0-97af8f10cfd0.webp"
    },
    {
      "id": "custom_fa6a5e2c-87f4-4175-a757-d98e889db2c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-a75a-746f-a9c4-1897d157abba.webp",
      "image_media": {
        "alt_text": "U-shaped kitchen with wood cabinets, white stove and microwave, and granite countertops.",
        "public_id": "019d20b0-a75a-746f-a9c4-1897d157abba",
        "storage_key": "property/6767906449165641/019d20b0-a75a-746f-a9c4-1897d157abba.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen with granite counters, wood cabinets, and white appliances.",
      "link": "",
      "alt_text": "U-shaped kitchen with wood cabinets, white stove and microwave, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-3958-75da-ae20-0ca9738323fe.webp"
    },
    {
      "id": "custom_419bd020-7fa4-4733-adad-dba733fb0468",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-ad7c-76de-b626-d64380396377.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, stove, microwave, and light wood cabinets.",
        "public_id": "019d20b0-ad7c-76de-b626-d64380396377",
        "storage_key": "property/6767906449165641/019d20b0-ad7c-76de-b626-d64380396377.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen with white appliances, ample cabinet space, and tile flooring.",
      "link": "",
      "alt_text": "Kitchen with white refrigerator, stove, microwave, and light wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-3b60-769b-8ff7-770260b73c55.webp"
    },
    {
      "id": "custom_89a51d58-02bd-4e67-b201-62b66ce894ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-afdb-742f-a4a2-12a3cc31e28f.webp",
      "image_media": {
        "alt_text": "Living room with a beige sofa, rustic wood coffee table, fireplace, and windows.",
        "public_id": "019d20b0-afdb-742f-a4a2-12a3cc31e28f",
        "storage_key": "property/6767906449165641/019d20b0-afdb-742f-a4a2-12a3cc31e28f.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Apartment",
      "description": "Cozy apartment living room with a fireplace, neutral tones, and seating for entertaining.",
      "link": "",
      "alt_text": "Living room with a beige sofa, rustic wood coffee table, fireplace, and windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165641/019cfb4c-68f4-77fe-9836-691eb02481e4.webp"
    },
    {
      "id": "custom_e92cb592-59c7-45b2-8109-bf274fd3e91b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-b919-7741-974a-09c235a4c561.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white wire shelving and carpet.",
        "public_id": "019d20b0-b919-7741-974a-09c235a4c561",
        "storage_key": "property/6767906449165641/019d20b0-b919-7741-974a-09c235a4c561.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with white wire shelving and neutral carpet, ideal for organized storage.",
      "link": "",
      "alt_text": "Empty walk-in closet with white wire shelving and carpet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4b-ff77-770e-8520-7912f6288bf9.webp"
    },
    {
      "id": "custom_148e399b-9e49-4088-84d4-8b1be5fcc018",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-ba0f-7489-9a4e-0aab065b8912.webp",
      "image_media": {
        "alt_text": "Laundry closet with a front-loading washer on the left and a top-loading dryer on the right.",
        "public_id": "019d20b0-ba0f-7489-9a4e-0aab065b8912",
        "storage_key": "property/6767906449165641/019d20b0-ba0f-7489-9a4e-0aab065b8912.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Compact apartment laundry closet featuring a front-loading washer and a top-loading dryer.",
      "link": "",
      "alt_text": "Laundry closet with a front-loading washer on the left and a top-loading dryer on the right.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4b-f6d7-70bd-ab6d-30757980234c.webp"
    },
    {
      "id": "custom_4b6f4733-aa49-4bd4-85ef-0d1114e4a441",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-be81-701d-a608-d6df0067ad47.webp",
      "image_media": {
        "alt_text": "Laundry closet with a wall-mounted electrical panel, water hookups, wire shelf, and wicker chair.",
        "public_id": "019d20b0-be81-701d-a608-d6df0067ad47",
        "storage_key": "property/6767906449165641/019d20b0-be81-701d-a608-d6df0067ad47.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Compact apartment laundry closet with wire shelf, utility panel, water hookups, and a wicker chair on tiled floor.",
      "link": "",
      "alt_text": "Laundry closet with a wall-mounted electrical panel, water hookups, wire shelf, and wicker chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4b-f6e6-77a5-9b19-448afa302e80.webp"
    },
    {
      "id": "custom_2446f594-f52a-49b8-ba14-c97089cb8863",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-c3e2-73ca-b3ce-b4185b77d78a.webp",
      "image_media": {
        "alt_text": "Silhouette of a city skyline at sunset with an orange sky.",
        "public_id": "019d20b0-c3e2-73ca-b3ce-b4185b77d78a",
        "storage_key": "property/6767906449165641/019d20b0-c3e2-73ca-b3ce-b4185b77d78a.webp",
        "width": 1024,
        "height": 681
      },
      "title": "Lifestyle",
      "description": "Silhouetted city skyline at sunset with a warm orange gradient sky.",
      "link": "",
      "alt_text": "Silhouette of a city skyline at sunset with an orange sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165641/019cfb4c-6ad7-76f0-8c0b-43348e26b1ca.webp"
    },
    {
      "id": "custom_f4bef31b-1577-46aa-9306-6f86a8f5beda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-c751-7497-8b46-cba714f30be5.webp",
      "image_media": {
        "alt_text": "Aerial view of a city neighborhood with a church steeple in the foreground and distant skyline.",
        "public_id": "019d20b0-c751-7497-8b46-cba714f30be5",
        "storage_key": "property/6767906449165641/019d20b0-c751-7497-8b46-cba714f30be5.webp",
        "width": 1024,
        "height": 576
      },
      "title": "Lifestyle",
      "description": "Aerial view of a residential block with a church in the foreground and the distant city skyline.",
      "link": "",
      "alt_text": "Aerial view of a city neighborhood with a church steeple in the foreground and distant skyline.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165641/019cfb4c-6e1b-71a0-8058-7d425668d56c.webp"
    },
    {
      "id": "custom_7b8a2478-e5f1-4312-a77b-d8b4f4e2e430",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d20b0-ca41-7449-8780-9dddb9936469.webp",
      "image_media": {
        "alt_text": "Outdoor landscaped pond with rock formations and a glowing golden statue at sunset.",
        "public_id": "019d20b0-ca41-7449-8780-9dddb9936469",
        "storage_key": "property/6767906449165641/019d20b0-ca41-7449-8780-9dddb9936469.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Lifestyle",
      "description": "Exterior view of a residential community featuring a pond, rock landscaping, and a central golden statue.",
      "link": "",
      "alt_text": "Outdoor landscaped pond with rock formations and a glowing golden statue at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165641/019cfb4c-6f0f-75e6-a450-a832c9f09e98.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_d0d2c411-529c-41eb-a07f-e78efd3bbe30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Topgolf Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "13313 Pawnee Dr, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Entertainment venue blending technology, dining, and golf with a sports bar, and rooftop seating.",
      "poi_long_description": "People say this restaurant offers a fun atmosphere with games, kid clubs, and toddler clubs. They also highlight the affordable pricing, especially for groups, and the friendly and helpful staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-b9dc-76f9-b9dd-b1467defa7b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b9dc-76f9-b9dd-b1467defa7b4",
        "storage_key": "property/6767906449165641/019d2709-b9dc-76f9-b9dd-b1467defa7b4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17880991546737991946&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-oklahoma-city",
      "poi_latitude": "35.6027127",
      "poi_longitude": "-97.5351879",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-607-7154",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eb1a-70ba-bc84-bc5499c5ce50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eb1a-70ba-bc84-bc5499c5ce50",
        "storage_key": "property/6767906449165641/019d2709-eb1a-70ba-bc84-bc5499c5ce50.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc0r8qRocsocRCqEU_xILJvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8d03b20a-e817-4db5-a4c5-88d1d5999c91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "8400 N Oklahoma Ave, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Bar with games such as pickleball and bocce and an on-site restaurant menu that encompasses wings to chicken sandwiches.",
      "poi_long_description": "People say this restaurant offers a fun day of pickleball, cornhole, drinks, and snacks. They also highlight the friendly staff, the perfect atmosphere for all ages, and the great experience for families and friends.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-ba7f-769d-8f5c-ef7539381606.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ba7f-769d-8f5c-ef7539381606",
        "storage_key": "property/6767906449165641/019d2709-ba7f-769d-8f5c-ef7539381606.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://chickennpickle.com/location/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4621211403201137082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chicken-n-pickle---oklahoma-city",
      "poi_latitude": "35.5570464",
      "poi_longitude": "-97.5088888",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-839-7011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eb1a-70ba-bc84-bc5499c5ce50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eb1a-70ba-bc84-bc5499c5ce50",
        "storage_key": "property/6767906449165641/019d2709-eb1a-70ba-bc84-bc5499c5ce50.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDbbROHYZsocRusnJd0nXIUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a02ce82f-2043-4f64-a6df-c87aaf560a87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Main Event Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "1441 W Memorial Rd, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Family-friendly venue offering bowling, laser tag and arcade games, along with pizza and burgers, plus a ropes course.",
      "poi_long_description": "People say this restaurant offers a variety of fun games, including bowling, laser tag, and arcade games, and the pizza is great. They also highlight the friendly staff, the fun atmosphere, and the good drinks.\n\nOther reviews mention some games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-b9df-747a-988d-11cbc6cba28e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b9df-747a-988d-11cbc6cba28e",
        "storage_key": "property/6767906449165641/019d2709-b9df-747a-988d-11cbc6cba28e.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/oklahoma/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=10621058190493493742&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "main-event-oklahoma-city",
      "poi_latitude": "35.6102071",
      "poi_longitude": "-97.5381584",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-751-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eb1a-70ba-bc84-bc5499c5ce50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eb1a-70ba-bc84-bc5499c5ce50",
        "storage_key": "property/6767906449165641/019d2709-eb1a-70ba-bc84-bc5499c5ce50.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bkHxccsocR7ikexyaUZZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0b82e1ad-a37d-49aa-a400-d0670643867d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2100 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Chain serving steaks and ribs in a casual setting featuring a jukebox and line dancers.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, chicken fried steak, and ribs, and the rolls with cinnamon butter are a highlight. They also highlight the friendly and accommodating staff, and the family-friendly atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-ba58-730c-8e3d-11c34cdad333.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ba58-730c-8e3d-11c34cdad333",
        "storage_key": "property/6767906449165641/019d2709-ba58-730c-8e3d-11c34cdad333.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/oklahoma-city-north-memorial-rd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=3657567219942529703&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.6078943",
      "poi_longitude": "-97.5503319",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-755-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eb1a-70ba-bc84-bc5499c5ce50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eb1a-70ba-bc84-bc5499c5ce50",
        "storage_key": "property/6767906449165641/019d2709-eb1a-70ba-bc84-bc5499c5ce50.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYzghGscsocRp5rJBgJKwjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_69dc4235-2fba-46bd-834f-b6e5f2b1a418",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "4901 NE 122nd St, Edmond, OK 73013, USA",
      "poi_short_description": "Relaxed chain restaurant featuring pancakes and other home-style dishes alongside a gift shop.",
      "poi_long_description": "People say this restaurant serves delicious southern fried chicken, meatloaf, and hashbrown casserole. They also highlight the affordable prices, the cozy and welcoming atmosphere, and the friendly and attentive service.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-beb2-7246-a128-fa8d20eeb6c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-beb2-7246-a128-fa8d20eeb6c3",
        "storage_key": "property/6767906449165641/019d2709-beb2-7246-a128-fa8d20eeb6c3.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/ok/edmond/351/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=15158410616723402160&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "35.5956279",
      "poi_longitude": "-97.4341583",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-478-7119",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eb1a-70ba-bc84-bc5499c5ce50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eb1a-70ba-bc84-bc5499c5ce50",
        "storage_key": "property/6767906449165641/019d2709-eb1a-70ba-bc84-bc5499c5ce50.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXeXacgEisocRsO1OqSR-XdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8296ca24-7861-4555-b71f-86adbf282944",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Quail Springs Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Shopping destination with a cinema, a food court, a kids' play area, and an arcade.",
      "poi_long_description": "People say this shopping center offers a variety of stores, a food court, a movie theater, and an arcade. They also highlight the fun atmosphere, the clean environment, and the good prices for the arcade and movies.\n\nOther reviews mention the food court can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-bfa8-731e-8565-e7af6a76cccc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bfa8-731e-8565-e7af6a76cccc",
        "storage_key": "property/6767906449165641/019d2709-bfa8-731e-8565-e7af6a76cccc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.quailspringsmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=254102542958583292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quail-springs-mall",
      "poi_latitude": "35.6130282",
      "poi_longitude": "-97.5584437",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-254-4979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eb15-756b-b85f-a4f28b2f3a06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eb15-756b-b85f-a4f28b2f3a06",
        "storage_key": "property/6767906449165641/019d2709-eb15-756b-b85f-a4f28b2f3a06.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS_2JfGccsocR_N2RoerAhgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_22020c35-7a36-4555-ab85-48a5dd87f057",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Crest Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "2200 W 15th St #124, Edmond, OK 73013, USA",
      "poi_short_description": "Supermarket featuring aisles of fresh groceries, baked goods and a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-bef0-7605-8d8b-460bffc1e8a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bef0-7605-8d8b-460bffc1e8a3",
        "storage_key": "property/6767906449165641/019d2709-bef0-7605-8d8b-460bffc1e8a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.crestfoodsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9428274884093566538&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crest-foods",
      "poi_latitude": "35.6368691",
      "poi_longitude": "-97.5127608",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-330-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eb40-7664-a8bd-4b20942e1f61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eb40-7664-a8bd-4b20942e1f61",
        "storage_key": "property/6767906449165641/019d2709-eb40-7664-a8bd-4b20942e1f61.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVSeJIYgesocRSl4izw3214I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a3595dca-4e04-4102-acf2-3226b618c7d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "The Home Depot, 1901 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "Home-improvement chain offering paint, tools, and building materials, plus installation services.",
      "poi_long_description": "People say this home improvement store has helpful and knowledgeable staff who are willing to assist with any task. They also highlight the friendly and efficient customer service, and the clean and well-stocked store.\n\nSome reviews mention the staff can be difficult to locate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-bf53-778b-8194-dcb62a1abd85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bf53-778b-8194-dcb62a1abd85",
        "storage_key": "property/6767906449165641/019d2709-bf53-778b-8194-dcb62a1abd85.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Edmond/OK/Edmond/73013/3907?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5451913410994265011&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.6346297",
      "poi_longitude": "-97.4849931",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-330-0151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eb15-756b-b85f-a4f28b2f3a06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eb15-756b-b85f-a4f28b2f3a06",
        "storage_key": "property/6767906449165641/019d2709-eb15-756b-b85f-a4f28b2f3a06.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9xQ7Wf4esocRs1uAoFwWqUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_85d198c3-ef6b-48e0-a825-1ad7531e28f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "2400 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Home improvement chain with a wide selection of tools, appliances and paint for DIYers.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-c375-718c-b136-17fb4ad39517.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c375-718c-b136-17fb4ad39517",
        "storage_key": "property/6767906449165641/019d2709-c375-718c-b136-17fb4ad39517.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Oklahoma-City/0535?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-535-_-na-_-0-_-0&y_source=1_MTE4MzI1OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9854502234558219169&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "35.6067382",
      "poi_longitude": "-97.5561463",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-936-2060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eb15-756b-b85f-a4f28b2f3a06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eb15-756b-b85f-a4f28b2f3a06",
        "storage_key": "property/6767906449165641/019d2709-eb15-756b-b85f-a4f28b2f3a06.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ80ErRm8csocRocMiKZI5wog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_64896ae5-8726-452f-a3d0-4bcef0abefd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "University of Central Oklahoma",
      "poi_type": "Education",
      "poi_address": "100 N University Dr, Edmond, OK 73034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-c40e-76fb-857e-1f96e114f1c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c40e-76fb-857e-1f96e114f1c6",
        "storage_key": "property/6767906449165641/019d2709-c40e-76fb-857e-1f96e114f1c6.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.uco.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17296425383341636856&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-central-oklahoma",
      "poi_latitude": "35.657506",
      "poi_longitude": "-97.4709491",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-974-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eae5-777d-b449-21c12011e10c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eae5-777d-b449-21c12011e10c",
        "storage_key": "property/6767906449165641/019d2709-eae5-777d-b449-21c12011e10c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvZ0xm_BNr4cR-Lwg6j4_CfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c423564d-04c8-4910-a07a-29593239b809",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Oklahoma Christian University",
      "poi_type": "Education",
      "poi_address": "2501 E Memorial Rd, Edmond, OK 73013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-c3d8-7034-ba67-277b3a91a22a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c3d8-7034-ba67-277b3a91a22a",
        "storage_key": "property/6767906449165641/019d2709-c3d8-7034-ba67-277b3a91a22a.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.oc.edu/?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6907680163806340117&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-christian-university",
      "poi_latitude": "35.6126232",
      "poi_longitude": "-97.4697937",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-425-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eae5-777d-b449-21c12011e10c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eae5-777d-b449-21c12011e10c",
        "storage_key": "property/6767906449165641/019d2709-eae5-777d-b449-21c12011e10c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN68XpyQfsocRFWSwsYIC3V8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_00604f8f-9773-4074-a965-9afab116e4e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Edmond Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "10 S Blvd, Edmond, OK 73034, USA",
      "poi_short_description": "Popular, kid-friendly facility offering books for all ages, magazines, music, movies, programs, computers and toy areas.",
      "poi_long_description": "People say this public library offers a huge selection of books, including online audio and e-books through the Libby app. They highlight the convenient self-checkout system, the ability to reserve books online, and the calm and clean atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-c538-738c-b176-a9cf495dcaa2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c538-738c-b176-a9cf495dcaa2",
        "storage_key": "property/6767906449165641/019d2709-c538-738c-b176-a9cf495dcaa2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=5308985467338173646&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edmond-library---metropolitan-library-system",
      "poi_latitude": "35.6542015",
      "poi_longitude": "-97.4778675",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-341-9282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eae5-777d-b449-21c12011e10c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eae5-777d-b449-21c12011e10c",
        "storage_key": "property/6767906449165641/019d2709-eae5-777d-b449-21c12011e10c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ73psmrMfsocRzixngidOrUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_8377f799-68ff-4f6b-b51c-19289d137307",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "The Village Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "10307 N Pennsylvania Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Public library featuring DVDs and quiet areas for study and reading.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-c891-7628-89b8-4608f576aac0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c891-7628-89b8-4608f576aac0",
        "storage_key": "property/6767906449165641/019d2709-c891-7628-89b8-4608f576aac0.webp",
        "width": 1280,
        "height": 382
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6591062255135426801&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-village-library---metropolitan-library-system",
      "poi_latitude": "35.5755065",
      "poi_longitude": "-97.5498468",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-755-0710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eae5-777d-b449-21c12011e10c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eae5-777d-b449-21c12011e10c",
        "storage_key": "property/6767906449165641/019d2709-eae5-777d-b449-21c12011e10c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt5LnnJMbsocR8QjVOTMoeFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_0da76319-174f-4646-b91d-c75ebaa303f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Frontier City",
      "poi_type": "Entertainment",
      "poi_address": "11501 N I- 35 Service Rd, Oklahoma City, OK 73131, USA",
      "poi_short_description": "Theme park with dozens of rides, including roller coasters, plus live entertainment.",
      "poi_long_description": "People say this theme park offers a variety of rides, including roller coasters, water rides, and a water park, as well as live shows and a Fright Fest event. They also highlight the season pass is a great value, the staff is friendly, and the park is clean with plenty of shade.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-c8fa-77a5-afba-6784b0e2e08a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c8fa-77a5-afba-6784b0e2e08a",
        "storage_key": "property/6767906449165641/019d2709-c8fa-77a5-afba-6784b0e2e08a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sixflags.com/frontiercity",
      "poi_directions_map_url": "https://maps.google.com/?cid=7374031908058551867&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "frontier-city",
      "poi_latitude": "35.5856674",
      "poi_longitude": "-97.4394665",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-478-2140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eea8-7686-bc82-2bbe9823e6aa",
        "storage_key": "property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEzIo0KYYsocRO9Y5evPSVWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_8eb544bb-3c20-4c3c-9856-4ad1601ee98e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "National Cowboy & Western Heritage Museum",
      "poi_type": "Entertainment",
      "poi_address": "1700 NE 63rd St, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Western heritage and cowboy history come to life at this museum with gardens, restaurants and a gift shop.",
      "poi_long_description": "People say this heritage museum offers a vast collection of Western art, historical artifacts, and engaging exhibits, including a recreation of an old West town and a rodeo exhibit. They highlight the educational and immersive experience, and the beautiful outdoor sculptures and gardens. They also like the friendly and knowledgeable staff, and the well-maintained and clean facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-c8d8-77e5-ac9e-fa544a9d3f74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c8d8-77e5-ac9e-fa544a9d3f74",
        "storage_key": "property/6767906449165641/019d2709-c8d8-77e5-ac9e-fa544a9d3f74.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://nationalcowboymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4849781199640138445&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "national-cowboy--western-heritage-museum",
      "poi_latitude": "35.5356997",
      "poi_longitude": "-97.4831286",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-478-2250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eedd-7756-a5f9-a766e4733e77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eedd-7756-a5f9-a766e4733e77",
        "storage_key": "property/6767906449165641/019d2709-eedd-7756-a5f9-a766e4733e77.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-cenbQZsocRzRLrSk7iTUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_29163744-9d55-4503-8e38-d7988fa52f58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Blue Zoo Aquarium Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd Suite 125A, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Mall-based attraction featuring sharks, stingrays, snakes and other marine life plus a playground for kids.",
      "poi_long_description": "People say this aquarium offers a variety of interactive experiences, including stingray petting and feeding, bird feeding, and a mermaid show. They also highlight the family-friendly atmosphere, the friendly and helpful staff, and the fun play area for children.\n\nSome reviews mention the aquarium can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-c9a9-7176-90b1-bb5af1623df2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c9a9-7176-90b1-bb5af1623df2",
        "storage_key": "property/6767906449165641/019d2709-c9a9-7176-90b1-bb5af1623df2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://oklahomacity.bluezoo.us/?utm_source=google&utm_medium=organic&utm_campaign=Google+Business+Profile+-+OKC",
      "poi_directions_map_url": "https://maps.google.com/?cid=5242468447430833348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-zoo-aquarium-oklahoma-city",
      "poi_latitude": "35.6125884",
      "poi_longitude": "-97.5573925",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 208-912-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eea8-7686-bc82-2bbe9823e6aa",
        "storage_key": "property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4zKmxcdsocRxPRO80b9wEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_a2db2708-139c-4c3a-b191-6887b2ad0ebb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Sky Zone",
      "poi_type": "Entertainment",
      "poi_address": "2525 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "Children's entertainment center featuring indoor trampolines and other activities such as SkySlam basketball.",
      "poi_long_description": "People say this amusement park offers a fun trampoline park experience. They also highlight the friendly staff and management, and the clean and well-maintained facilities.\n\nOther reviews mention the price can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-cd28-7696-b8eb-ddb881ee050a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cd28-7696-b8eb-ddb881ee050a",
        "storage_key": "property/6767906449165641/019d2709-cd28-7696-b8eb-ddb881ee050a.webp",
        "width": 1200,
        "height": 1200
      },
      "poi_business_url": "https://www.skyzone.com/edmond/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11100529412539313541&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone",
      "poi_latitude": "35.6300623",
      "poi_longitude": "-97.4862479",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-359-1631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eea8-7686-bc82-2bbe9823e6aa",
        "storage_key": "property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ75ZG2_wesocRhW0uBbAADZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_bbbe633a-8a78-4d29-949b-66a435db8957",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Chad Richison Stadium",
      "poi_type": "Entertainment",
      "poi_address": "100 E University Dr, Edmond, OK 73034, USA",
      "poi_short_description": "High school stadium hosting football games, including state championship events.",
      "poi_long_description": "People say this stadium offers a great experience for watching soccer games. They highlight the facilities are clean and well-maintained, and the sound system is top-notch. They also like the wide variety of concession options and the convenient credit card acceptance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-cf70-764f-8a38-6d454a0762c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cf70-764f-8a38-6d454a0762c5",
        "storage_key": "property/6767906449165641/019d2709-cf70-764f-8a38-6d454a0762c5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://bronchosports.com/sports/2011/6/10/FB_0610111744.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=10132052462898693569&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chad-richison-stadium",
      "poi_latitude": "35.6615051",
      "poi_longitude": "-97.4707673",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-974-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-ef20-742e-ab1a-498f60daad07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ef20-742e-ab1a-498f60daad07",
        "storage_key": "property/6767906449165641/019d2709-ef20-742e-ab1a-498f60daad07.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhdKbbbcfsocRwcWyeAhInIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_0716bff1-6934-42d2-acc1-96020222149f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Mitch Park YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "2901 Marilyn Williams Dr, Edmond, OK 73003, USA",
      "poi_short_description": "Clean sports facility featuring a fitness center and an outdoor track, as well as an indoor pool, disc golf and basketball courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-ce6b-70ef-9364-9871ccd80627.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ce6b-70ef-9364-9871ccd80627",
        "storage_key": "property/6767906449165641/019d2709-ce6b-70ef-9364-9871ccd80627.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://ymcaokc.org/branches/mitch-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15994863836961186949&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mitch-park-ymca",
      "poi_latitude": "35.6847017",
      "poi_longitude": "-97.5083114",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-330-4016",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eea8-7686-bc82-2bbe9823e6aa",
        "storage_key": "property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-eeHJvT1sYcRhSTQUOor-d0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_dd26d03b-bf64-4cb0-9022-8588fd0e83ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "2563 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers excellent tennis courts. They also highlight the facility has many pools and pickleball courts.\n\nOther reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-cf35-723a-be82-518477a48bc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cf35-723a-be82-518477a48bc1",
        "storage_key": "property/6767906449165641/019d2709-cf35-723a-be82-518477a48bc1.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/oklahoma-city.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=13614994550085944548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "35.61423510000001",
      "poi_longitude": "-97.5602129",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-832-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eea8-7686-bc82-2bbe9823e6aa",
        "storage_key": "property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWAnM3kdsocR5ITAcGgt8rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ee8d6e17-e619-4372-92a6-ce379c5b7b05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Crunch Fitness - Oklahoma City, OK",
      "poi_type": "Health and Wellness",
      "poi_address": "12508 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Gym, part of a chain, offering yoga, cardio and weights rooms, and tanning beds.",
      "poi_long_description": "People say this gym offers a wide variety of group fitness classes, modern equipment, and childcare, and has a friendly and motivating atmosphere.\n\nOther reviews mention membership cancellation can be difficult and there can be hidden fees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-d18e-76b8-b1d0-92eade440e3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d18e-76b8-b1d0-92eade440e3c",
        "storage_key": "property/6767906449165641/019d2709-d18e-76b8-b1d0-92eade440e3c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/quail-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097941148085874568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---oklahoma-city-ok",
      "poi_latitude": "35.5969373",
      "poi_longitude": "-97.565988",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-497-8160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eea8-7686-bc82-2bbe9823e6aa",
        "storage_key": "property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Z8NgOkdsocRiG_leCo9oFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ecaa92c2-35c7-477d-b6ea-9571a449552f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Oklahoma Gold Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "3001 Technology Dr, Edmond, OK 73013, USA",
      "poi_short_description": "Gym for kids offering classes in gymnastics and tumbling, plus birthday parties.",
      "poi_long_description": "People say this gymnastics center offers fun classes and birthday parties for young children. They highlight the positive and encouraging atmosphere, and the confidence children gain. They also like the kind, welcoming, and dedicated staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-d358-7408-88c2-fb9dcb772f98.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d358-7408-88c2-fb9dcb772f98",
        "storage_key": "property/6767906449165641/019d2709-d358-7408-88c2-fb9dcb772f98.webp",
        "width": 1280,
        "height": 775
      },
      "poi_business_url": "http://www.oklahomagoldgymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=191096937127623553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-gold-gymnastics",
      "poi_latitude": "35.6263031",
      "poi_longitude": "-97.4926773",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-341-1175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eae5-777d-b449-21c12011e10c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eae5-777d-b449-21c12011e10c",
        "storage_key": "property/6767906449165641/019d2709-eae5-777d-b449-21c12011e10c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw7GpO_AesocRgTso36bppgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c80feb68-4429-4621-8bda-2993b9c5eb48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Crunch Fitness - Edmond",
      "poi_type": "Health and Wellness",
      "poi_address": "2121 W Danforth Rd, Edmond, OK 73003, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, cardio machines, and powerlifting stations, and has a spacious layout with an outdoor workout area.\n\nOther reviews mention the restrooms can be poorly maintained and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-d3f3-738e-8a62-008c6f03119c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d3f3-738e-8a62-008c6f03119c",
        "storage_key": "property/6767906449165641/019d2709-d3f3-738e-8a62-008c6f03119c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/edmond",
      "poi_directions_map_url": "https://maps.google.com/?cid=8462207099918585172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---edmond",
      "poi_latitude": "35.6692665",
      "poi_longitude": "-97.5106805",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-920-1940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eea8-7686-bc82-2bbe9823e6aa",
        "storage_key": "property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo1bUEHcfsocRVI1vzoXMb3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_45a6482a-6750-4f5d-b930-949303e388ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2209 W Edmond Rd, Edmond, OK 73003, USA",
      "poi_short_description": "Laid-back fitness center featuring workout machines plus massage chairs and tanning beds.",
      "poi_long_description": "People say this gym offers a good selection of equipment and machines, including free weights and tanning beds. They highlight the clean and tidy facility, and the convenient location and hours. They also like the friendly and helpful staff, and the welcoming and non-judgmental atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-d420-75a9-ae4c-e96b17424a85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d420-75a9-ae4c-e96b17424a85",
        "storage_key": "property/6767906449165641/019d2709-d420-75a9-ae4c-e96b17424a85.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/edmond-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12798186502624872755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.6543154",
      "poi_longitude": "-97.5129943",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-697-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eea8-7686-bc82-2bbe9823e6aa",
        "storage_key": "property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu4H7420esocRM4knAtFKnLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6204626d-f14f-458b-9592-0862eee8ba83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "TB Fitness Club",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 W Hefner Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-d5e7-74aa-a035-eb4749a6ac4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d5e7-74aa-a035-eb4749a6ac4d",
        "storage_key": "property/6767906449165641/019d2709-d5e7-74aa-a035-eb4749a6ac4d.webp",
        "width": 1280,
        "height": 730
      },
      "poi_business_url": "https://tbfitclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12558554567901756546&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tb-fitness-club",
      "poi_latitude": "35.5816564",
      "poi_longitude": "-97.5782735",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-849-9173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eea8-7686-bc82-2bbe9823e6aa",
        "storage_key": "property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfqhdqYbsocRgrwkaNfySK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_061374a6-a6c2-475b-a789-5e6ce9f04736",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Metro Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "7420 Broadway Ext, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Gymnastics center offering classes and birthday parties for kids of various ages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-d7e1-7693-9dae-165e5edd0053.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d7e1-7693-9dae-165e5edd0053",
        "storage_key": "property/6767906449165641/019d2709-d7e1-7693-9dae-165e5edd0053.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metrogymokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3312655711320854520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metro-gymnastics",
      "poi_latitude": "35.5464292",
      "poi_longitude": "-97.5132581",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-848-5308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eae5-777d-b449-21c12011e10c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eae5-777d-b449-21c12011e10c",
        "storage_key": "property/6767906449165641/019d2709-eae5-777d-b449-21c12011e10c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSXSRwJwZsocR-M9yeNHq-C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f27c1cfd-be5f-4ff7-83cb-c62683cb7a83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "2340 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Beauty retailer offering cosmetics, fragrances, and skin and hair care products, plus salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-d813-72eb-9996-68f7ad4aa7d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d813-72eb-9996-68f7ad4aa7d2",
        "storage_key": "property/6767906449165641/019d2709-d813-72eb-9996-68f7ad4aa7d2.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/oklahoma-city-ok-128",
      "poi_directions_map_url": "https://maps.google.com/?cid=17751417342740012859&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "35.606929",
      "poi_longitude": "-97.553605",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-302-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eea8-7686-bc82-2bbe9823e6aa",
        "storage_key": "property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmaQHR2kcsocROx-6rQW0WfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_d21504d6-e20e-440f-9ea7-a20856498eb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Scissors & Scotch",
      "poi_type": "Health and Wellness",
      "poi_address": "13230 Pawnee Dr #202, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Upscale barber shop for beard trims and straight-razor shaves alongside a private lounge and a full bar with whisky. Waxing, manicures and massages are also offered.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-d853-77ac-a0f6-00c128a578ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d853-77ac-a0f6-00c128a578ac",
        "storage_key": "property/6767906449165641/019d2709-d853-77ac-a0f6-00c128a578ac.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://scissorsscotch.com/locations/ok/oklahoma-city/chisholm-creek/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17460232672315201299&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "scissors--scotch",
      "poi_latitude": "35.60419",
      "poi_longitude": "-97.5337642",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-486-4902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eea8-7686-bc82-2bbe9823e6aa",
        "storage_key": "property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62z3xRocsocRE1cEcRs1T_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_31b76cf7-cbf9-49cf-826a-ee7ad706d62a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "INTEGRIS Health Edmond Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4801 Integris Pkwy, Edmond, OK 73034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-da2a-76df-ad0c-8177ca7a712a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-da2a-76df-ad0c-8177ca7a712a",
        "storage_key": "property/6767906449165641/019d2709-da2a-76df-ad0c-8177ca7a712a.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://integrisok.com/locations/hospital/edmond-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=11204265952285374783&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integris-health-edmond-hospital",
      "poi_latitude": "35.6444304",
      "poi_longitude": "-97.4183639",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-657-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-efc2-7668-8d68-429cf5d49e34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-efc2-7668-8d68-429cf5d49e34",
        "storage_key": "property/6767906449165641/019d2709-efc2-7668-8d68-429cf5d49e34.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJufe603CjdYgRPzn5VoWMfZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_88668115-f690-48d9-b036-1fcac834d696",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "McBride Orthopedic Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "9600 Broadway Ext, Oklahoma City, OK 73114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-dc7b-73de-bddf-ddcb6c75bf60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-dc7b-73de-bddf-ddcb6c75bf60",
        "storage_key": "property/6767906449165641/019d2709-dc7b-73de-bddf-ddcb6c75bf60.webp",
        "width": 1280,
        "height": 930
      },
      "poi_business_url": "http://www.mcboh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10772037074811406715&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mcbride-orthopedic-hospital",
      "poi_latitude": "35.5683383",
      "poi_longitude": "-97.510895",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-486-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-efc2-7668-8d68-429cf5d49e34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-efc2-7668-8d68-429cf5d49e34",
        "storage_key": "property/6767906449165641/019d2709-efc2-7668-8d68-429cf5d49e34.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJWwn8qDQXsocRe8l4l6X2fZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_52b0dc8b-1486-4b25-893c-217f776cdb74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "E.C. Hafer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1034 S Bryant Ave, Edmond, OK 73034, USA",
      "poi_short_description": "Large park with duck ponds and a variety of playground equipment.",
      "poi_long_description": "Visitors say this park offers a paved walking trail, playgrounds, picnic tables, pavilions, a sand volleyball court, workout stations, and a duck pond. They also highlight the scenic views, abundance of trees, and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-dc8d-74be-8eff-27678ad8ebfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-dc8d-74be-8eff-27678ad8ebfe",
        "storage_key": "property/6767906449165641/019d2709-dc8d-74be-8eff-27678ad8ebfe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://edmondok.com/facilities/Facility/Details/9",
      "poi_directions_map_url": "https://maps.google.com/?cid=2633511566572246196&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ec-hafer-park",
      "poi_latitude": "35.6428821",
      "poi_longitude": "-97.4551926",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-359-4630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-f22e-7069-aa96-be3d8f60978c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f22e-7069-aa96-be3d8f60978c",
        "storage_key": "property/6767906449165641/019d2709-f22e-7069-aa96-be3d8f60978c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJOa4APJ4fsocRtNRrHdEcjCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e19a3b3e-1eb5-406a-96b7-38f1f59aee2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Kickingbird Golf",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1600 E Danforth Rd, Edmond, OK 73034, USA",
      "poi_short_description": "Well-kept course featuring bunkers, a practice area, a driving range and a pro shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-de00-710a-8a14-5278b3a972dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-de00-710a-8a14-5278b3a972dd",
        "storage_key": "property/6767906449165641/019d2709-de00-710a-8a14-5278b3a972dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kickingbirdgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15575429422620550350&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kickingbird-golf",
      "poi_latitude": "35.6659317",
      "poi_longitude": "-97.4576492",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-341-5350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-f2d5-723f-95f6-494cc6e27e56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f2d5-723f-95f6-494cc6e27e56",
        "storage_key": "property/6767906449165641/019d2709-f2d5-723f-95f6-494cc6e27e56.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJuxVdOesfsocRziR3p4kKJ9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_0a77b87e-d37b-4f17-b04a-5ccd97cb4ca1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Rose Creek Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17031 N May Ave, Edmond, OK 73012, USA",
      "poi_short_description": "Private golf course with an on-site eatery, pickleball courts, a clubhouse and a patio.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-e015-76b5-b37b-a62fdf5e920f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e015-76b5-b37b-a62fdf5e920f",
        "storage_key": "property/6767906449165641/019d2709-e015-76b5-b37b-a62fdf5e920f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rosecreekgc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14897560691660009268&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rose-creek-country-club",
      "poi_latitude": "35.6449907",
      "poi_longitude": "-97.5686808",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-330-8220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-f2d5-723f-95f6-494cc6e27e56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f2d5-723f-95f6-494cc6e27e56",
        "storage_key": "property/6767906449165641/019d2709-f2d5-723f-95f6-494cc6e27e56.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8IOAwgdsocRNK83toTEvs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_d63aa479-5be4-4288-ab1e-82a1b8fc2209",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Mitch Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Edmond, OK 73003, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-e186-722d-ba2f-c5676332e300.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e186-722d-ba2f-c5676332e300",
        "storage_key": "property/6767906449165641/019d2709-e186-722d-ba2f-c5676332e300.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.edmondok.gov/facilities/facility/details/Mitch-Park-19",
      "poi_directions_map_url": "https://maps.google.com/?cid=1740714302256427325&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mitch-park",
      "poi_latitude": "35.6826377",
      "poi_longitude": "-97.5065914",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-f22e-7069-aa96-be3d8f60978c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f22e-7069-aa96-be3d8f60978c",
        "storage_key": "property/6767906449165641/019d2709-f22e-7069-aa96-be3d8f60978c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfU7CegD1sYcRPbFvaW9CKBg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e4b617fe-334e-49f3-a638-9f5801de03aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "The Golf Club of Edmond",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4001 Fairfax Dr, Edmond, OK 73034, USA",
      "poi_short_description": "Public golf course with a driving range offering tournaments, plus a food option.",
      "poi_long_description": "Golfers say this public golf course offers excellent course conditions, a great selection of merchandise, and tasty food. They also highlight the friendly and helpful staff, and the overall value for money.\n\nSome reviews mention the course can be challenging.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-e126-772f-8aea-509e7370be2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e126-772f-8aea-509e7370be2a",
        "storage_key": "property/6767906449165641/019d2709-e126-772f-8aea-509e7370be2a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.golfedmond.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15577750115198172692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-golf-club-of-edmond",
      "poi_latitude": "35.6849669",
      "poi_longitude": "-97.4296555",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-359-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-f2d5-723f-95f6-494cc6e27e56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-f2d5-723f-95f6-494cc6e27e56",
        "storage_key": "property/6767906449165641/019d2709-f2d5-723f-95f6-494cc6e27e56.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJMWS32wggsocRFP4vADJJL9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_b570aad2-a437-494c-a138-5984093c6ed5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Costco Member Service Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14501 Bogert Pkwy, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-e397-75bb-82ee-a4b06880b379.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e397-75bb-82ee-a4b06880b379",
        "storage_key": "property/6767906449165641/019d2709-e397-75bb-82ee-a4b06880b379.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3497496067160567460&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "costco-member-service-center",
      "poi_latitude": "35.6183037",
      "poi_longitude": "-97.5748651",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eea8-7686-bc82-2bbe9823e6aa",
        "storage_key": "property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX18i7nkdsocRpG5ufiSaiTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_31d261dd-eba6-4ed1-b8e2-f8866354cf98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "CFS Brands",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4711 E Hefner Rd, Oklahoma City, OK 73131, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-e594-731c-95a2-e7d9afafd76b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e594-731c-95a2-e7d9afafd76b",
        "storage_key": "property/6767906449165641/019d2709-e594-731c-95a2-e7d9afafd76b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cfsbrands.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6460468295741084389&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cfs-brands",
      "poi_latitude": "35.5808644",
      "poi_longitude": "-97.435523",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-654-8210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eea8-7686-bc82-2bbe9823e6aa",
        "storage_key": "property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzZmxMAoisocR5RJSmq8xqFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_43d5ba5d-2102-4e83-9597-a006408f2bcf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Love's South Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 Vineyard Blvd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-e6e3-738f-8217-6c250e63014b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e6e3-738f-8217-6c250e63014b",
        "storage_key": "property/6767906449165641/019d2709-e6e3-738f-8217-6c250e63014b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4360911662846330364&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-south-building",
      "poi_latitude": "35.5769306",
      "poi_longitude": "-97.5501889",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eea8-7686-bc82-2bbe9823e6aa",
        "storage_key": "property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfjgpJsbsocR_EXQYA0ShTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d7292c27-efc4-4476-afe4-9787bc61f6c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Love's Corporate - Contact Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1331 W Memorial Rd Suite 100, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-e5b2-73ec-9261-5353af783751.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e5b2-73ec-9261-5353af783751",
        "storage_key": "property/6767906449165641/019d2709-e5b2-73ec-9261-5353af783751.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "http://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4980310977560095404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate---contact-center",
      "poi_latitude": "35.61081310000001",
      "poi_longitude": "-97.5351028",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eea8-7686-bc82-2bbe9823e6aa",
        "storage_key": "property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKbub2xkcsocRrKpygHKeHUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2f1f87f4-3b87-4c3f-8a32-3d2d00950ed2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Citizens Caring For Children",
      "poi_type": "Major Employers & Offices",
      "poi_address": "730 W Wilshire Blvd #112, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.citizenscaringforchildren.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7043692473786242074&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "citizens-caring-for-children",
      "poi_latitude": "35.5485243",
      "poi_longitude": "-97.5251897",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-753-4099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-eea8-7686-bc82-2bbe9823e6aa",
        "storage_key": "property/6767906449165641/019d2709-eea8-7686-bc82-2bbe9823e6aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjcTOsyoasocRGhQfX_w4wGE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fb52d104-55e9-4705-917a-1c3b0b2a6208",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Orvis Risner Elementary School",
      "poi_type": "Education",
      "poi_address": "2801 S Rankin St, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://orvisrisner.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7839498494672854300&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "orvis-risner-elementary-school",
      "poi_latitude": "35.62797190000001",
      "poi_longitude": "-97.4754065",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-340-2984",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0577-72e5-bc28-101876ff6823.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0577-72e5-bc28-101876ff6823",
        "storage_key": "property/6767906449165641/019cfb4d-0577-72e5-bc28-101876ff6823.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4WH-RhsfsocRHF0vcFh-y2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_24565fd2-654d-4d6f-a566-bc64373a0ff9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Clegern Elementary School",
      "poi_type": "Education",
      "poi_address": "601 S Jackson St, Edmond, OK 73034, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://clegern.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17825185290999789366&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "clegern-elementary-school",
      "poi_latitude": "35.6481517",
      "poi_longitude": "-97.4767561",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-340-2955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0577-72e5-bc28-101876ff6823.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0577-72e5-bc28-101876ff6823",
        "storage_key": "property/6767906449165641/019cfb4d-0577-72e5-bc28-101876ff6823.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-5dl260fsocRNnePjZTHX_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_71367acd-47c3-4e94-bc3b-d691724ce346",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Central Middle School",
      "poi_type": "Education",
      "poi_address": "500 E 9th St #5401, Edmond, OK 73034, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5830503139636657575&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "central-middle-school",
      "poi_latitude": "35.6449524",
      "poi_longitude": "-97.4727989",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-340-2890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0577-72e5-bc28-101876ff6823.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0577-72e5-bc28-101876ff6823",
        "storage_key": "property/6767906449165641/019cfb4d-0577-72e5-bc28-101876ff6823.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU4iF0agfsocRp73X07Yb6lA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7d595a13-5ba8-4183-a1f0-501b234627f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Cimarron Middle School",
      "poi_type": "Education",
      "poi_address": "3701 S Bryant Ave, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-b6d7-703a-b1cd-6a7f5d091840.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-b6d7-703a-b1cd-6a7f5d091840",
        "storage_key": "property/6767906449165641/019d7913-b6d7-703a-b1cd-6a7f5d091840.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://cimarron.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14977112001491695191&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cimarron-middle-school",
      "poi_latitude": "35.6193426",
      "poi_longitude": "-97.4618711",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-340-2935",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0577-72e5-bc28-101876ff6823.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0577-72e5-bc28-101876ff6823",
        "storage_key": "property/6767906449165641/019cfb4d-0577-72e5-bc28-101876ff6823.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtzcgRhUfsocRV_YmYgNk2c8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_9c3cc167-4c36-4cb6-9fd5-ebc356754129",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Edmond Memorial High School Auditorium",
      "poi_type": "Education",
      "poi_address": "1000 E 15th St, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-b73c-735c-b5b4-e58e150b4ac3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-b73c-735c-b5b4-e58e150b4ac3",
        "storage_key": "property/6767906449165641/019d7913-b73c-735c-b5b4-e58e150b4ac3.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3122312273495245387&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "edmond-memorial-high-school-auditorium",
      "poi_latitude": "35.6361121",
      "poi_longitude": "-97.4697362",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-340-2850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0780-723e-a216-995e0fde4e9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0780-723e-a216-995e0fde4e9c",
        "storage_key": "property/6767906449165641/019cfb4d-0780-723e-a216-995e0fde4e9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXT1I--0fsocRS8KGU3iuVCs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "auditorium"
    },
    {
      "id": "custom_02af3a94-bfc3-4155-a952-291723e4eb4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Edmond Santa Fe High School",
      "poi_type": "Education",
      "poi_address": "1901 W 15th St, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-b641-725d-8484-1fc37b6e8fa5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-b641-725d-8484-1fc37b6e8fa5",
        "storage_key": "property/6767906449165641/019d7913-b641-725d-8484-1fc37b6e8fa5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://santafe.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3158354544559100067&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "edmond-santa-fe-high-school",
      "poi_latitude": "35.6401779",
      "poi_longitude": "-97.5088169",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-340-2230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0577-72e5-bc28-101876ff6823.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0577-72e5-bc28-101876ff6823",
        "storage_key": "property/6767906449165641/019cfb4d-0577-72e5-bc28-101876ff6823.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPS_GbGIesocRo5Avf7m61Cs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_373024fd-822c-4825-9a71-c9a24f4dc564",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Gabriella's Italian Grill & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "3601 S Broadway Ste 600, Edmond, OK 73013, USA",
      "poi_short_description": "Chef-owned eatery crafting refined homestyle Italian cuisine in a relaxed, family-friendly ambiance.",
      "poi_long_description": "People say this Italian restaurant serves delicious pasta, pizza, and other Italian dishes. They also highlight the authentic ingredients, family atmosphere, and friendly staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-b637-745a-9954-4a303a3afe7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-b637-745a-9954-4a303a3afe7c",
        "storage_key": "property/6767906449165641/019d7913-b637-745a-9954-4a303a3afe7c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.gabriellasokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6000322265861139267&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gabriella-s-italian-grill-pizzeria",
      "poi_latitude": "35.619277",
      "poi_longitude": "-97.4906807",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-478-4955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0574-74cc-add3-369b9b88b242.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0574-74cc-add3-369b9b88b242",
        "storage_key": "property/6767906449165641/019cfb4d-0574-74cc-add3-369b9b88b242.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK_PxPrEZsocRQyuFSk9tRVM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_a908b9bf-a78c-4fa0-b1d1-483f860fa63c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Boulevard Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "505 S Blvd, Edmond, OK 73034, USA",
      "poi_short_description": "High-end eatery serving USDA prime steaks and seafood, as well as an extensive wine list and martini options.",
      "poi_long_description": "People say this steakhouse serves perfectly cooked steaks, delicious Caesar salad, and amazing family-style sides. They highlight the relaxing atmosphere, attentive service, and well-crafted cocktails. They also like the cozy and welcoming vibe, and the attentive and caring staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-be46-74dc-8c1b-cbbf8992acf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-be46-74dc-8c1b-cbbf8992acf9",
        "storage_key": "property/6767906449165641/019d7913-be46-74dc-8c1b-cbbf8992acf9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.boulevardsteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14677149613743957038&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "boulevard-steakhouse",
      "poi_latitude": "35.64937270000001",
      "poi_longitude": "-97.4784421",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-715-2333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0574-74cc-add3-369b9b88b242.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0574-74cc-add3-369b9b88b242",
        "storage_key": "property/6767906449165641/019cfb4d-0574-74cc-add3-369b9b88b242.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiwD9m60fsocRLmR4ks-1r8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_1f133171-1b91-49ff-aa8b-db1d69f17ec2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Brent's Cajun Seafood And Oyster Bar",
      "poi_type": "Restaurants",
      "poi_address": "3005 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "New Orleans–themed bar/eatery offering Cajun seafood staples, plus weekend brunch & outdoor seating.",
      "poi_long_description": "People say this seafood restaurant serves delicious Cajun food, including charbroiled oysters, crawfish, and gumbo. They also highlight the generous portions, reasonable prices, and excellent service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-bed9-740c-8774-cffa33a9f7fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-bed9-740c-8774-cffa33a9f7fa",
        "storage_key": "property/6767906449165641/019d7913-bed9-740c-8774-cffa33a9f7fa.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "https://www.brentscajunfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8187144985205302848&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "brent-s-cajun-seafood-and-oyster-bar",
      "poi_latitude": "35.6253831",
      "poi_longitude": "-97.486042",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-285-0911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0574-74cc-add3-369b9b88b242.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0574-74cc-add3-369b9b88b242",
        "storage_key": "property/6767906449165641/019cfb4d-0574-74cc-add3-369b9b88b242.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLYpsneMesocRQGbIl_yUnnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_9ee9b0ca-e2dc-44a1-8c36-00cefd62561d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Gyro House",
      "poi_type": "Restaurants",
      "poi_address": "3209 S Broadway #127, Edmond, OK 73013, USA",
      "poi_short_description": "Halal Mediterranean cuisine including familiar dishes such as gyros served in an easygoing setting.",
      "poi_long_description": "People say this Mediterranean restaurant serves delicious gyro sandwiches, chicken shawarma, and baklava. They highlight the generous portions, fresh ingredients, and authentic flavors, as well as the reasonable prices. They also like the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-c415-76d7-af7d-b28afba83d0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c415-76d7-af7d-b28afba83d0b",
        "storage_key": "property/6767906449165641/019d7913-c415-76d7-af7d-b28afba83d0b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://gyrohouseedmond.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7802735282445170389&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "gyro-house",
      "poi_latitude": "35.6244111",
      "poi_longitude": "-97.4874431",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-906-2363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0574-74cc-add3-369b9b88b242.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0574-74cc-add3-369b9b88b242",
        "storage_key": "property/6767906449165641/019cfb4d-0574-74cc-add3-369b9b88b242.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPy70cswfsocR1TaNEmbiSGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_39717d61-373b-4682-9f02-a0bbbfd1bf7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Opus Prime Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "800 W Memorial Rd, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Elegant steakhouse with a full bar & patio offering dry-aged prime beef, seafood & a vast wine list.",
      "poi_long_description": "Diners say this steak house serves up fantastic steaks, including ribeye and wagyu, and delicious lobster mac and cheese. They also highlight the excellent service and the warm, tasty bread.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-c128-7572-9b49-71f89122b89c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c128-7572-9b49-71f89122b89c",
        "storage_key": "property/6767906449165641/019d7913-c128-7572-9b49-71f89122b89c.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://opusprimesteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15668684757345628192&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "opus-prime-steakhouse",
      "poi_latitude": "35.6086003",
      "poi_longitude": "-97.5281249",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-607-6787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0574-74cc-add3-369b9b88b242.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0574-74cc-add3-369b9b88b242",
        "storage_key": "property/6767906449165641/019cfb4d-0574-74cc-add3-369b9b88b242.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqUSZOhwcsocRIPApQ8VZctk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_c074535e-2e16-49e7-ad42-7d94a1c74471",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Charleston's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3409 S Broadway #400, Edmond, OK 73013, USA",
      "poi_short_description": "Relaxed hangout serving classic pub fare, such as burgers, ribs & tenders, plus wine & cocktails.",
      "poi_long_description": "People say this American restaurant serves delicious croissants, salads, and shrimp cargot. They highlight the fresh ingredients, generous portions, and upscale atmosphere. They also like the attentive and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-c6b7-7100-b7fb-47258d7fdbca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c6b7-7100-b7fb-47258d7fdbca",
        "storage_key": "property/6767906449165641/019d7913-c6b7-7100-b7fb-47258d7fdbca.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://charlestons.com/locations/charlestons-edmond/",
      "poi_directions_map_url": "https://maps.google.com/?cid=294390371871737234&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "charleston-s-restaurant",
      "poi_latitude": "35.62256929999999",
      "poi_longitude": "-97.4880033",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-478-4949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0574-74cc-add3-369b9b88b242.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0574-74cc-add3-369b9b88b242",
        "storage_key": "property/6767906449165641/019cfb4d-0574-74cc-add3-369b9b88b242.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyU9nnuYesocRksW1xHviFQQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_97fcec56-311d-4d01-83ee-d3afb273493b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Braum's Ice Cream & Dairy Store",
      "poi_type": "Restaurants",
      "poi_address": "2420 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "Longtime Oklahoma-based chain offering fast-food burgers, ice cream & a full range of groceries.",
      "poi_long_description": "People say this ice cream shop offers tasty burgers, fries, and yogurt waffle cone twists. They also highlight the fresh milk, ice cream, and the friendly and helpful staff.\n\nOther reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-c67e-75f1-af6a-e65c5f1bda38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c67e-75f1-af6a-e65c5f1bda38",
        "storage_key": "property/6767906449165641/019d7913-c67e-75f1-af6a-e65c5f1bda38.webp",
        "width": 800,
        "height": 451
      },
      "poi_business_url": "http://www.braums.com/stores/ice-cream-store-burger-restaurant-braums-2420-s-broadway/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11118946916778477465&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "braum-s-ice-cream-dairy-store",
      "poi_latitude": "35.6291222",
      "poi_longitude": "-97.4839897",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-341-3808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0574-74cc-add3-369b9b88b242.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0574-74cc-add3-369b9b88b242",
        "storage_key": "property/6767906449165641/019cfb4d-0574-74cc-add3-369b9b88b242.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNR2x0PwesocRmYcBY09vTpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "custom_7b1ea697-58ae-4a07-afb9-7a080a191e9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Earl's Rib Palace",
      "poi_type": "Restaurants",
      "poi_address": "2121 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "Easygoing choice for hickory-smoked BBQ specialties, plus baked potatoes & burgers.",
      "poi_long_description": "People say this barbecue restaurant serves fantastic ribs, brisket, and fried okra. They also highlight the delicious smoked chicken sandwich, fries, and deviled eggs, and the fast, friendly service.\n\nSome reviews mention the food can be dry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-c811-739b-939b-5459bec78c60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c811-739b-939b-5459bec78c60",
        "storage_key": "property/6767906449165641/019d7913-c811-739b-939b-5459bec78c60.webp",
        "width": 1280,
        "height": 474
      },
      "poi_business_url": "http://www.earlsribpalace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16998788312585583648&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "earl-s-rib-palace",
      "poi_latitude": "35.6317976",
      "poi_longitude": "-97.4848943",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-715-1166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0574-74cc-add3-369b9b88b242.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0574-74cc-add3-369b9b88b242",
        "storage_key": "property/6767906449165641/019cfb4d-0574-74cc-add3-369b9b88b242.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJraKORfwesocRILy5J-jT5-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_413ea972-eb80-462b-8647-b72ff579575a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "The Garage Door Company",
      "poi_type": "Restaurants",
      "poi_address": "1733 S Fretz Ave Suite D, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-d427-773e-9764-4fd0fede79bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d427-773e-9764-4fd0fede79bb",
        "storage_key": "property/6767906449165641/019d7913-d427-773e-9764-4fd0fede79bb.webp",
        "width": 1280,
        "height": 757
      },
      "poi_business_url": "https://garagedoorok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2946025113235322627&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-garage-door-company",
      "poi_latitude": "35.6361696",
      "poi_longitude": "-97.4893141",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-260-8034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0780-723e-a216-995e0fde4e9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0780-723e-a216-995e0fde4e9c",
        "storage_key": "property/6767906449165641/019cfb4d-0780-723e-a216-995e0fde4e9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-atM60fsocRA3fFVTti4ig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supplier"
    },
    {
      "id": "custom_44b0ee29-97d9-4f5a-972f-7a46ed903d29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "All About Cha Stylish Tea and Coffee",
      "poi_type": "Restaurants",
      "poi_address": "12444 NW 10th St Bldg G,suite 203, Yukon, OK 73099, USA",
      "poi_short_description": "Popular hangout specializing in coffee and tea drinks, along with a menu of Korean standards.",
      "poi_long_description": "People say this coffee shop offers a wide variety of delicious drinks, food, and desserts, including the Bulgogi Breakfast Wrap, White Mocha Green Freddo Love, and strawberry rhubarb square. They also highlight the peaceful and bright atmosphere, and the friendly, helpful, and accommodating staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-d0c9-727c-8702-9016960bbd79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d0c9-727c-8702-9016960bbd79",
        "storage_key": "property/6767906449165641/019d7913-d0c9-727c-8702-9016960bbd79.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://allaboutchayukon.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1157672793143874459&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "all-about-cha-stylish-tea-and-coffee",
      "poi_latitude": "35.4774267",
      "poi_longitude": "-97.7494799",
      "poi_miles_from_property": "23.9 mi",
      "poi_walking_minutes": "8 hours 50 mins",
      "poi_biking_minutes": "2 hours 25 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 405-397-6650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-ff1d-725d-8530-89ebd97246b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-ff1d-725d-8530-89ebd97246b8",
        "storage_key": "property/6767906449165641/019d7913-ff1d-725d-8530-89ebd97246b8.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJmYWhR2QIsocRm5N5kUXhEBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_170f8ba5-d823-4051-afb1-b2fde0a69039",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Panang 5 Thai Restaurant Edmond",
      "poi_type": "Restaurants",
      "poi_address": "3325 S Blvd #149, Edmond, OK 73013, USA",
      "poi_short_description": "Bustling restaurant preparing elevated Thai dishes, curries & seafood plates, with lunch specials.",
      "poi_long_description": "People say this Thai restaurant serves delicious Panang curry, Pad Thai, and chicken fried rice. They highlight the generous portions, custom spice levels, and fresh, hot food. They also like the fair prices and cozy, clean atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-d1d2-7376-a2e5-1a7ebde719b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d1d2-7376-a2e5-1a7ebde719b8",
        "storage_key": "property/6767906449165641/019d7913-d1d2-7376-a2e5-1a7ebde719b8.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://panangthaifood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2459207964557602091&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "panang-5-thai-restaurant-edmond",
      "poi_latitude": "35.622211",
      "poi_longitude": "-97.479797",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-285-5188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0574-74cc-add3-369b9b88b242.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0574-74cc-add3-369b9b88b242",
        "storage_key": "property/6767906449165641/019cfb4d-0574-74cc-add3-369b9b88b242.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe36QR6ATsocRK21ERJ3cICI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_6a9525f4-2603-4097-9e56-43be7a8a254b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Boulevard Plaza Shopping Center",
      "poi_type": "Restaurants",
      "poi_address": "3212 S Blvd, Edmond, OK 73013, USA",
      "poi_short_description": "Plaza with several businesses including a pizza parlor, a liquor store and a donut shop.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-d538-7282-8c1c-ce9da90ee103.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d538-7282-8c1c-ce9da90ee103",
        "storage_key": "property/6767906449165641/019d7913-d538-7282-8c1c-ce9da90ee103.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1408202557022014415&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "boulevard-plaza-shopping-center",
      "poi_latitude": "35.6241938",
      "poi_longitude": "-97.4773957",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0572-77ca-846a-10d462ee83ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0572-77ca-846a-10d462ee83ca",
        "storage_key": "property/6767906449165641/019cfb4d-0572-77ca-846a-10d462ee83ca.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvx3XMBwfsocRzwsYv8PwihM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e1fdfb51-9ac8-442d-90e8-a1165e1e2589",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Shoppes On Broadway",
      "poi_type": "Restaurants",
      "poi_address": "3248 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "Shopping mall featuring Hobby Lobby, as well as other retailers and fast-food restaurants.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-d720-770f-a8dd-9a588f24e17a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d720-770f-a8dd-9a588f24e17a",
        "storage_key": "property/6767906449165641/019d7913-d720-770f-a8dd-9a588f24e17a.webp",
        "width": 656,
        "height": 874
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5707196026152173320&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "shoppes-on-broadway",
      "poi_latitude": "35.624096",
      "poi_longitude": "-97.4848489",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-562-3521",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0572-77ca-846a-10d462ee83ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0572-77ca-846a-10d462ee83ca",
        "storage_key": "property/6767906449165641/019cfb4d-0572-77ca-846a-10d462ee83ca.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJx96blOMesocRCD9SOowINE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_b63172ea-b383-4c5f-ae28-f5a9dca4bb13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Natural Grocers",
      "poi_type": "Restaurants",
      "poi_address": "3325 S Blvd #169, Edmond, OK 73013, USA",
      "poi_short_description": "Retail chain focused on natural & organic groceries, supplements & household products.",
      "poi_long_description": "People say this grocery store offers a wide selection of organic foods, vitamins, and nutritional supplements. They highlight the knowledgeable and friendly staff, and the generous and helpful service. They also like the fun and stress-free shopping experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-db12-77fd-985d-aa766dd8e5c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-db12-77fd-985d-aa766dd8e5c7",
        "storage_key": "property/6767906449165641/019d7913-db12-77fd-985d-aa766dd8e5c7.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.naturalgrocers.com/store/edmond-boulevard-st",
      "poi_directions_map_url": "https://maps.google.com/?cid=1156336947571507514&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "natural-grocers",
      "poi_latitude": "35.6220736",
      "poi_longitude": "-97.4791638",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-285-9201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0770-7214-9700-6f94abae03d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0770-7214-9700-6f94abae03d7",
        "storage_key": "property/6767906449165641/019cfb4d-0770-7214-9700-6f94abae03d7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJedNxYR4fsocROsGoyFMiDBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_782b54f0-b948-4a13-b733-4429da8f460c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Restaurants",
      "poi_address": "13200 N Western Ave, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "People say this warehouse store offers a wide variety of products, including fresh produce, easy-cook meals, and clothing. They also highlight the great deals, awesome prices, and the availability of unique items.\n\nOther reviews mention the checkout process can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-dc32-721d-a61b-6d2e5180f1d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-dc32-721d-a61b-6d2e5180f1d4",
        "storage_key": "property/6767906449165641/019d7913-dc32-721d-a61b-6d2e5180f1d4.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/oklahoma-city-OK-1350.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=14122877494864452912&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "35.6041749",
      "poi_longitude": "-97.5303089",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-832-5102",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0572-77ca-846a-10d462ee83ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0572-77ca-846a-10d462ee83ca",
        "storage_key": "property/6767906449165641/019cfb4d-0572-77ca-846a-10d462ee83ca.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJaye3fSUdsocRMB3BX0GK_sM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_e3574f94-d575-402c-afaf-d70e23b5caad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Arctic Edge Ice Arena",
      "poi_type": "Entertainment",
      "poi_address": "14613 N Kelley Ave, Edmond, OK 73013, USA",
      "poi_short_description": "Standard ice rink with public skate sessions, lessons, birthday party deals & an arcade/snack bar.",
      "poi_long_description": "People say this ice skating rink offers fun ice skating and roller derby events. They also highlight the comfortable seating, good snack prices, and friendly staff.\n\nSome reviews mention the ice can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-dbd8-774b-bb24-5b02aea61ca1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-dbd8-774b-bb24-5b02aea61ca1",
        "storage_key": "property/6767906449165641/019d7913-dbd8-774b-bb24-5b02aea61ca1.webp",
        "width": 1038,
        "height": 582
      },
      "poi_business_url": "https://arctic-edge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16354595636634646757&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "arctic-edge-ice-arena",
      "poi_latitude": "35.6190919",
      "poi_longitude": "-97.4975965",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-748-5454",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0780-723e-a216-995e0fde4e9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0780-723e-a216-995e0fde4e9c",
        "storage_key": "property/6767906449165641/019cfb4d-0780-723e-a216-995e0fde4e9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRx-ZhukesocR5fjCxhQy9-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_skating_rink"
    },
    {
      "id": "custom_d5bfa973-8ded-4ab8-bdce-f721d4ccbfd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Surge Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "24 E 33rd St, Edmond, OK 73013, USA",
      "poi_short_description": "Active entertainment center featuring trampolines, obstacle courses, dodgeball and zip lines.",
      "poi_long_description": "Some visitors say this amusement center offers a variety of activities, including trampolines, a zip line, a climbing wall, and a foam pit, and is a great place for birthday parties. \n\nOther reviews mention the staff can be impolite and management can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-dfb1-77bc-b1ff-95124d11fce8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-dfb1-77bc-b1ff-95124d11fce8",
        "storage_key": "property/6767906449165641/019d7913-dfb1-77bc-b1ff-95124d11fce8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://surgefun.com/locations/OklahomaCity/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11963842351677829399&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "surge-adventure-park",
      "poi_latitude": "35.62197889999999",
      "poi_longitude": "-97.4842846",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-216-3992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0780-723e-a216-995e0fde4e9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0780-723e-a216-995e0fde4e9c",
        "storage_key": "property/6767906449165641/019cfb4d-0780-723e-a216-995e0fde4e9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9c_UrnIfsocRF_GHUDsbCKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_e7aa412e-d267-4eb3-99df-1ea8a4abd571",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Edmond Dog Park",
      "poi_type": "Entertainment",
      "poi_address": "379 E 33rd St, Edmond, OK 73013, USA",
      "poi_short_description": "Popular public park with an agility course for dogs to run around and socialize.",
      "poi_long_description": "People say this dog park offers a large area for dogs to run, with separate sections for small and large dogs, and a lake for swimming. They highlight the availability of water, waste bags, and benches, as well as the friendly atmosphere and opportunities for dogs to socialize and play. They also like the agility equipment and toys provided for dogs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-e31b-71e0-87ee-9018dc3c0a44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e31b-71e0-87ee-9018dc3c0a44",
        "storage_key": "property/6767906449165641/019d7913-e31b-71e0-87ee-9018dc3c0a44.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.edmondok.gov/Facilities.aspx?Page=detail&RID=8",
      "poi_directions_map_url": "https://maps.google.com/?cid=16442623112282946553&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "edmond-dog-park",
      "poi_latitude": "35.622589",
      "poi_longitude": "-97.4759277",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-359-4630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0582-755f-9658-47cdbdd71f57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0582-755f-9658-47cdbdd71f57",
        "storage_key": "property/6767906449165641/019cfb4d-0582-755f-9658-47cdbdd71f57.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6VWgSxkfsocR-btAl5ruL-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_f6c3ae74-efdf-4ca0-9f49-e2b449300542",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Bowlero Edmond",
      "poi_type": "Entertainment",
      "poi_address": "3501 S Blvd, Edmond, OK 73013, USA",
      "poi_short_description": "Relaxed, party-ready venue for bowling blacklight lanes, an arcade, laser tag, and rope courses.",
      "poi_long_description": "People say this bowling alley offers well-maintained lanes, a family-friendly atmosphere, and a great summer bowling pass. They also highlight the friendly and helpful staff, and the fun arcade games.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-e48e-70ab-9f3d-36cc1b8937a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e48e-70ab-9f3d-36cc1b8937a4",
        "storage_key": "property/6767906449165641/019d7913-e48e-70ab-9f3d-36cc1b8937a4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bowlero.com/location/bowlero-edmond?utm_source=gbp&utm_medium=organic&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=12348066556039309155&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bowlero-edmond",
      "poi_latitude": "35.62113009999999",
      "poi_longitude": "-97.4798013",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-348-3210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0780-723e-a216-995e0fde4e9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0780-723e-a216-995e0fde4e9c",
        "storage_key": "property/6767906449165641/019cfb4d-0780-723e-a216-995e0fde4e9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl8RLRR4fsocRY6eaHxwlXas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_ec2ae829-2df2-449f-a3ea-d6a2fd9c1daf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Margaret Annis Boys Centennial Arboretum",
      "poi_type": "Entertainment",
      "poi_address": "2108 Smiling Hill Blvd, Edmond, OK 73013, USA",
      "poi_short_description": "Tree collection dotted with winding paths that connect to dog parks and ponds (for fishing).",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-e77e-731c-87ea-848e2eb2e580.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e77e-731c-87ea-848e2eb2e580",
        "storage_key": "property/6767906449165641/019d7913-e77e-731c-87ea-848e2eb2e580.webp",
        "width": 1025,
        "height": 1280
      },
      "poi_business_url": "http://edmondok.com/index.aspx?nid=619",
      "poi_directions_map_url": "https://maps.google.com/?cid=15480665306844209438&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "margaret-annis-boys-centennial-arboretum",
      "poi_latitude": "35.6169772",
      "poi_longitude": "-97.4746243",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-359-4759",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0780-723e-a216-995e0fde4e9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0780-723e-a216-995e0fde4e9c",
        "storage_key": "property/6767906449165641/019cfb4d-0780-723e-a216-995e0fde4e9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO-pWayIfsocRHqEplRNf1tY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_7c39dc23-88a8-4fd9-8b7d-7698c85bd86a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Armstrong Auditorium",
      "poi_type": "Entertainment",
      "poi_address": "14400 S Bryant Rd B, Edmond, OK 73034, USA",
      "poi_short_description": "Beautiful venue for orchestral and ballet shows, plus Irish dance performances.",
      "poi_long_description": "People say this concert hall offers amazing performances, including Celtic Throne and the Three Italian Tenors. They highlight the beautiful venue with perfect acoustics, comfortable seating, and easy parking. They also like the friendly, helpful, and polite staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-e7f1-74bf-b3a4-67f71061cb1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e7f1-74bf-b3a4-67f71061cb1f",
        "storage_key": "property/6767906449165641/019d7913-e7f1-74bf-b3a4-67f71061cb1f.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://armstrongauditorium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11164165068248646155&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "armstrong-auditorium",
      "poi_latitude": "35.729949",
      "poi_longitude": "-97.457142",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 405-285-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0780-723e-a216-995e0fde4e9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0780-723e-a216-995e0fde4e9c",
        "storage_key": "property/6767906449165641/019cfb4d-0780-723e-a216-995e0fde4e9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5dhkcuD0sYcRCwLJsvoU75o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "concert_hall"
    },
    {
      "id": "custom_b2d48d83-0a9f-452e-b726-16488ab194a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Bickham-Rudkin Park",
      "poi_type": "Entertainment",
      "poi_address": "E 33rd St & Rankin Terrace, 379 E 33rd St, Edmond, OK 73013, USA",
      "poi_short_description": "Expansive public park known for its fishing pond, multi-use trails, dog run & playground.",
      "poi_long_description": "Visitors say this park has great walking trails and a scenic pond with benches. They also highlight the dog park and the good fishing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-ee08-7758-b2a2-67142e2fd516.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-ee08-7758-b2a2-67142e2fd516",
        "storage_key": "property/6767906449165641/019d7913-ee08-7758-b2a2-67142e2fd516.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://edmondok.com/Facilities/Facility/Details/3",
      "poi_directions_map_url": "https://maps.google.com/?cid=3768785765673346311&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bickham-rudkin-park",
      "poi_latitude": "35.6227456",
      "poi_longitude": "-97.4742366",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-359-4630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0582-755f-9658-47cdbdd71f57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0582-755f-9658-47cdbdd71f57",
        "storage_key": "property/6767906449165641/019cfb4d-0582-755f-9658-47cdbdd71f57.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJE6JpbxkfsocRByWCna9qTTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_50224baf-93f6-4dcc-ba02-0a52e64e8248",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Arcadia Lake",
      "poi_type": "Entertainment",
      "poi_address": "Arcadia Lake, Oklahoma, USA",
      "poi_short_description": "Man-made 1,820-acre lake constructed in 1987, popular for fishing, water sports & swimming.",
      "poi_long_description": "Man-made 1,820-acre lake constructed in 1987, popular for fishing, water sports & swimming.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-f0b7-704e-a478-7dbab0869050.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-f0b7-704e-a478-7dbab0869050",
        "storage_key": "property/6767906449165641/019d7913-f0b7-704e-a478-7dbab0869050.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13462816550137746152&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "arcadia-lake",
      "poi_latitude": "35.6315929",
      "poi_longitude": "-97.386775",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0780-723e-a216-995e0fde4e9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0780-723e-a216-995e0fde4e9c",
        "storage_key": "property/6767906449165641/019cfb4d-0780-723e-a216-995e0fde4e9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYY8vA0hsocR6NI1w1KI1bo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "lake"
    },
    {
      "id": "custom_a6d81788-e98c-409d-bb2c-140a74fab416",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Spring Creek Park",
      "poi_type": "Entertainment",
      "poi_address": "7200 E 15th St, Edmond, OK 73013, USA",
      "poi_short_description": "Recreational park featuring trails, picnic tables & a boat ramp, playground & a swimming beach.",
      "poi_long_description": "People say this park offers fishing, grilling, and scenic views. They highlight the remote location, opportunities for wildlife viewing, and the availability of picnic areas, playgrounds, and trails. They also like the well-maintained restrooms and organized parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-f2e8-7060-97a3-9d86743cf4e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-f2e8-7060-97a3-9d86743cf4e0",
        "storage_key": "property/6767906449165641/019d7913-f2e8-7060-97a3-9d86743cf4e0.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://edmondok.com/Facilities/Facility/Details/Spring-Creek-Park-11",
      "poi_directions_map_url": "https://maps.google.com/?cid=3613611343799604972&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "spring-creek-park",
      "poi_latitude": "35.6382223",
      "poi_longitude": "-97.3883114",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-216-7470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0582-755f-9658-47cdbdd71f57.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0582-755f-9658-47cdbdd71f57",
        "storage_key": "property/6767906449165641/019cfb4d-0582-755f-9658-47cdbdd71f57.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJq_3ORqEhsocR7FZ_F18gJjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_52f5ea27-f2cd-4ac9-abf3-daad7507e066",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "The HIVE Sports Complex",
      "poi_type": "Entertainment",
      "poi_address": "14414 N Lincoln Blvd #100, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-f2df-70ad-a1a9-8a6ba87a6107.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-f2df-70ad-a1a9-8a6ba87a6107",
        "storage_key": "property/6767906449165641/019d7913-f2df-70ad-a1a9-8a6ba87a6107.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "http://www.hivehoops.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18385766922256091775&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-hive-sports-complex",
      "poi_latitude": "35.616748",
      "poi_longitude": "-97.5016059",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-286-4726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0780-723e-a216-995e0fde4e9c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0780-723e-a216-995e0fde4e9c",
        "storage_key": "property/6767906449165641/019cfb4d-0780-723e-a216-995e0fde4e9c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN4aHG5UesocRf4ozlJpdJ_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_aae61024-059a-4935-bba8-1459b11eef4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Chisholm Creek",
      "poi_type": "Entertainment",
      "poi_address": "13230 Pawnee Dr #301, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Shopping mall with a playground, a variety of eateries, and a bar.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019d7913-f8b9-73e8-b7fe-fc076a4a2d0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-f8b9-73e8-b7fe-fc076a4a2d0f",
        "storage_key": "property/6767906449165641/019d7913-f8b9-73e8-b7fe-fc076a4a2d0f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://chisholmcreek.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8772336277965025515&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chisholm-creek",
      "poi_latitude": "35.6068863",
      "poi_longitude": "-97.53682",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-728-2780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-0572-77ca-846a-10d462ee83ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-0572-77ca-846a-10d462ee83ca",
        "storage_key": "property/6767906449165641/019cfb4d-0572-77ca-846a-10d462ee83ca.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_y5qixEdsocR67Bg8l2ZvXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_ade88b65-ecce-481f-9623-6c60a98ad0a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "poi_name": "Uptown Grocery and Co.",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "uptown-grocery-and-co",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_c939c7927a6c71bb6a2bc3da",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_d040300df1c3d6adc3047738",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_1ad01322c72682b31fa852d7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_cea0360667003152ad0c5b8e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a870841bfb3d3cd812f04812",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_27ce561b230069b30df81df7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_9945671c-b93a-442e-b007-7180ace4d20a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "rating": "5.0",
      "name": "Aditya Bhagat (Adi)",
      "text": "Absolutely loved staying here! The apartment was clean, stylish, and felt like home. Great location—close to everything but still quiet and safe. The host was super friendly and responsive, making check-in and communication easy. Highly recommend to anyone looking for a comfortable and hassle-free. Chad and Nicole in the office is always very helpfull and the team working there as well I was in unit 237 you get the best sunlight there. If you get lucky to get this unit take it as its a great unit.",
      "date": "2025-07-01",
      "title": ""
    },
    {
      "id": "custom_1c210650-127c-4661-9667-2535d3c372d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "rating": "5.0",
      "name": "Sherion Johnson",
      "text": "This is a geat place to live! Chad is very kind and does a great job being professional. Yet always working with you in any way needed. He definitely goes above & beyond even when he doesn't have to. Our family appreciates it.",
      "date": "2025-08-26",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_7299a151-d129-4cbf-a388-452005c63b10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4d-9f24-739e-b580-002d7192a192.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of apartment complex with pool and lounge chairs.",
        "public_id": "019cfb4d-9f24-739e-b580-002d7192a192",
        "storage_key": "property/6767906449165641/019cfb4d-9f24-739e-b580-002d7192a192.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Villas at Stonebridge Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f6d679170a7b90f5768c9e5&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-77a9-70ea-8c52-6214fcbe04a1",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "villas-at-stonebridge",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641"
    },
    {
      "lead_collector_id": "019cf79e-7814-72ab-a3f6-321d30ef6a81",
      "lead_source": "LANDING_PAGE",
      "name": "villas-at-stonebridge",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "generator",
      "page_item_url": "luxury-apartments-in-unit-laundry-edmond-ok",
      "search_query": "luxury apartments with in-unit laundry in Edmond OK",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover luxury living in Edmond, OK with in-unit laundry. Villas at Stonebridge offers this amenity for your convenience.",
      "page_copy": "At Villas at Stonebridge, we present you with exquisite luxury apartments featuring in-unit laundry facilities right in the heart of Edmond, OK. Immerse yourself in the convenience and elegance of our modern homes, where comfort and style meet practicality. Our one, two, and three-bedroom floor plans are designed with your lifestyle in mind, offering you unparalleled living arrangements.\n\nCome experience life at its finest with our array of top-notch amenities such as a sparkling pool, fitness center, and a welcoming clubhouse. Besides luxury living and in-unit laundry, enjoy the comfort of air conditioning, window coverings, and your personal patio, ensuring a perfect balance of indoor and outdoor living. Schedule a tour today and see why Villas at Stonebridge is your ideal home destination.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table set, in front of a grand building with columns.",
        "public_id": "019cfb4c-89b2-7571-8d2f-347d6d3ab2fe",
        "storage_key": "property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with In-Unit Laundry",
      "seo_description": "Explore luxury apartments with in-unit laundry at Villas at Stonebridge in Edmond, OK. Schedule a tour of your new home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-pool-stonebridge-neighborhood",
      "search_query": "pet-friendly apartments with pool in Stonebridge neighborhood",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Pool",
      "h2_subtitle": "Explore pet-friendly apartments with pool access in the Stonebridge neighborhood. Discover the comfort and convenience at Villas at Stonebridge.",
      "page_copy": "Welcome to Villas at Stonebridge, where pet-friendly living meets recreational bliss in the Stonebridge neighborhood. Our modern apartments not only welcome your furry friends with a dedicated pet play area but also provide you with access to a sparkling pool just a few steps away from your front door.\n\nThis vibrant community offers spacious one, two, and three-bedroom homes, complete with amenities like air conditioning, window coverings, and personal patios. Enjoy a well-rounded lifestyle as you relax with a dip in the pool or engage in a workout at our fitness center. Experience the perfect balance of comfort and luxury by scheduling a tour of our pet-friendly community today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table set, in front of a grand building with columns.",
        "public_id": "019cfb4c-89b2-7571-8d2f-347d6d3ab2fe",
        "storage_key": "property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Pool Access",
      "seo_description": "Discover pet-friendly apartments with pool access at Villas at Stonebridge in the Stonebridge neighborhood. Tour your new home today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "generator",
      "page_item_url": "gym-equipped-apartments-edmond-oklahoma-73013",
      "search_query": "gym equipped apartments in Edmond Oklahoma 73013",
      "category": "Amenity",
      "h1_title": "Gym Equipped Apartments in Edmond",
      "h2_subtitle": "Villas at Stonebridge in Edmond, OK 73013 offers gym equipped apartments. Experience fitness convenience right at home.",
      "page_copy": "For those who prioritize fitness and wellness, Villas at Stonebridge offers gym-equipped apartments in Edmond, Oklahoma. Nestled at the convenient location of Edmond, OK 73013, our community ensures that residents have unrestricted access to a well-equipped fitness center, perfect for maintaining an active lifestyle.\n\nBeyond our state-of-the-art gym facilities, our one, two, and three-bedroom apartments provide luxury living with a host of amenities. Whether you wish to relax by our sparkling pool, or enjoy a cozy evening on your personal patio, the options are plenty. With features like air conditioning, window coverings, and a welcoming clubhouse, Villas at Stonebridge provides everything you need for a comfortable and engaging living experience. Schedule a tour to explore life at its best.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table set, in front of a grand building with columns.",
        "public_id": "019cfb4c-89b2-7571-8d2f-347d6d3ab2fe",
        "storage_key": "property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gym Equipped Apartments in Edmond, OK",
      "seo_description": "Find gym-equipped apartments at Villas at Stonebridge in Edmond, OK 73013. Enjoy fitness and luxury living today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "generator",
      "page_item_url": "apartment-air-conditioning-dishwasher-near-edmond-ok",
      "search_query": "apartment with air conditioning and dishwasher near Edmond OK",
      "category": "Amenity",
      "h1_title": "Apartments with AC & Dishwasher",
      "h2_subtitle": "Discover apartments near Edmond, OK with air conditioning and dishwasher. Experience comfort at Villas at Stonebridge.",
      "page_copy": "Villas at Stonebridge invites you to discover the perfect blend of comfort and convenience with our apartments featuring air conditioning and dishwashers, located near Edmond, OK. These essential amenities ensure that your everyday living is as hassle-free as possible, making our homes ideal for both relaxation and efficiency.\n\nChoose from our thoughtfully designed one, two, or three-bedroom floor plans, each boasting modern comforts and style. Beyond in-home conveniences, enjoy exclusive access to community features like a sparkling pool, a well-equipped fitness center, and a welcoming clubhouse. With additional amenities such as a pet play area and personal patios, Villas at Stonebridge is the perfect place to call home. Schedule a tour today and explore our comfortable and well-equipped apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table set, in front of a grand building with columns.",
        "public_id": "019cfb4c-89b2-7571-8d2f-347d6d3ab2fe",
        "storage_key": "property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with AC & Dishwasher near Edmond",
      "seo_description": "Explore air-conditioned apartments with dishwashers near Edmond, OK at Villas at Stonebridge. Comfort and convenience await you!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "generator",
      "page_item_url": "spa-clubhouse-apartments-edmond-oklahoma",
      "search_query": "spa and clubhouse apartments in Edmond Oklahoma",
      "category": "Amenity",
      "h1_title": "Spa & Clubhouse Apartments in Edmond",
      "h2_subtitle": "Experience luxury at Villas at Stonebridge, offering spa-like amenities and a vibrant clubhouse in Edmond, Oklahoma.",
      "page_copy": "Welcome to Villas at Stonebridge, where spa-like relaxation meets vibrant community living in Edmond, Oklahoma. Our apartments provide access to a luxurious clubhouse where you can unwind and socialize with fellow residents. Elevate your living experience with our exclusive community amenities that cater to both relaxation and recreation.\n\nOur one, two, and three-bedroom apartments are designed with modern conveniences in mind, featuring air conditioning, patios, and more. As a resident, you'll enjoy the luxury of a sparkling pool, perfect for cooling off or enjoying a leisurely swim. Discover a lifestyle of comfort and community at Villas at Stonebridge, where a dynamic clubhouse and serene settings await. Contact us to schedule a tour and experience refined apartment living in Edmond today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table set, in front of a grand building with columns.",
        "public_id": "019cfb4c-89b2-7571-8d2f-347d6d3ab2fe",
        "storage_key": "property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spa & Clubhouse Apartments in Edmond",
      "seo_description": "Villas at Stonebridge offers spa and clubhouse amenities in Edmond, OK. Schedule a tour to experience luxury living today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-edmond-ok",
      "search_query": "one bedroom apartments in Edmond OK",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Edmond, OK",
      "h2_subtitle": "Explore the comfort and convenience of our one-bedroom apartments in Edmond, Oklahoma at Villas at Stonebridge.",
      "page_copy": "At Villas at Stonebridge, find your perfect retreat with our well-appointed one-bedroom apartments in Edmond, OK. These thoughtfully designed living spaces provide a harmonious blend of comfort and style, ideal for those seeking a modern lifestyle in a serene community setting.\n\nEach one-bedroom apartment offers a range of premium features, including air conditioning and patio access, ensuring you have the ultimate in-home comfort. The community boasts exceptional amenities such as a sparkling pool, pet play area, and a welcoming clubhouse, creating a lively, engaging environment. Discover the peace and practicality of living at Villas at Stonebridge and schedule a visit to your future home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table set, in front of a grand building with columns.",
        "public_id": "019cfb4c-89b2-7571-8d2f-347d6d3ab2fe",
        "storage_key": "property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Edmond, OK",
      "seo_description": "Discover stylish one-bedroom apartments at Villas at Stonebridge in Edmond, OK. Enjoy modern amenities and community comforts!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "generator",
      "page_item_url": "two-bedroom-rentals-stonebridge-neighborhood-edmond",
      "search_query": "two bedroom rentals Stonebridge neighborhood Edmond",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Rentals in Stonebridge",
      "h2_subtitle": "Find spacious two-bedroom rentals in the desirable Stonebridge neighborhood, Edmond. Welcome to Villas at Stonebridge.",
      "page_copy": "Villas at Stonebridge offers spacious two-bedroom rentals in the sought-after Stonebridge neighborhood of Edmond. Perfect for those seeking ample living space with a touch of sophistication, our two-bedroom apartments are designed to cater to your lifestyle needs. \n\nEnjoy features like air conditioning and private patios, along with the community amenities such as a sparkling pool, fitness center, and pet play area. Situated in a vibrant neighborhood, Villas at Stonebridge combines convenience with serene surroundings, making it an ideal choice for renters in Edmond. Schedule a tour today and discover your new two-bedroom home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table set, in front of a grand building with columns.",
        "public_id": "019cfb4c-89b2-7571-8d2f-347d6d3ab2fe",
        "storage_key": "property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Rentals in Stonebridge, Edmond",
      "seo_description": "Explore two-bedroom rentals in Edmond's Stonebridge neighborhood at Villas at Stonebridge. Spacious and stylish living awaits!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-73013",
      "search_query": "three bedroom apartments near 73013",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 73013",
      "h2_subtitle": "Discover spacious three-bedroom apartments near the 73013 area at Villas at Stonebridge in Edmond, Oklahoma.",
      "page_copy": "Experience expansive and comfortable living with our three-bedroom apartments near the 73013 area at Villas at Stonebridge. Designed to accommodate families or those in need of extra space, our apartments offer a perfect blend of style and functionality in Edmond, Oklahoma.\n\nEach apartment features thoughtful amenities such as air conditioning, window coverings, and patios, providing a cozy and inviting home environment. The community enhances your living experience with a sparkling pool, a fitness center, and an engaging clubhouse. Whether you're relaxing at home or enjoying the vibrant community, Villas at Stonebridge is the ideal choice for three-bedroom living near 73013. Contact us today and secure your perfect home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table set, in front of a grand building with columns.",
        "public_id": "019cfb4c-89b2-7571-8d2f-347d6d3ab2fe",
        "storage_key": "property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 73013",
      "seo_description": "Villas at Stonebridge offers three-bedroom apartments near 73013 in Edmond, OK. Discover spacious and modern living today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "generator",
      "page_item_url": "apartments-near-university-central-ok-edmond",
      "search_query": "apartments near university of central oklahoma edmond",
      "category": "School",
      "h1_title": "Apartments Near University of Central Oklahoma",
      "h2_subtitle": "Find ideal apartments near the University of Central Oklahoma at Villas at Stonebridge, perfect for students and faculty alike.",
      "page_copy": "Experience convenient living at Villas at Stonebridge, with prime apartments near the University of Central Oklahoma in Edmond. Our community offers an ideal location for students, faculty, and staff seeking ease of access to campus life combined with top-notch amenities and comfortable living spaces.\n\nChoose from our stylish one, two, or three-bedroom layouts, each thoughtfully designed with features like air conditioning and patios. Enjoy the community perks, including a fitness center, pet play area, and a sparkling pool. Villas at Stonebridge combines convenience and comfort, making it a top choice for anyone seeking apartments near the University of Central Oklahoma. Schedule a visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table set, in front of a grand building with columns.",
        "public_id": "019cfb4c-89b2-7571-8d2f-347d6d3ab2fe",
        "storage_key": "property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Central Oklahoma",
      "seo_description": "Discover Villas at Stonebridge, offering ideal apartments near the University of Central Oklahoma in Edmond with modern amenities and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "generator",
      "page_item_url": "apartments-close-ok-christian-university-73013",
      "search_query": "apartments close to oklahoma christian university 73013",
      "category": "School",
      "h1_title": "Apartments Close to Oklahoma Christian University",
      "h2_subtitle": "Explore apartments close to Oklahoma Christian University at Villas at Stonebridge, located within the 73013 area in Edmond.",
      "page_copy": "Villas at Stonebridge offers a prime living experience with apartments close to Oklahoma Christian University, ideal for both students and university staff. Nestled in the 73013 area, our community provides easy access to Edmond's vibrant campus life and offers luxurious amenities designed to complement your lifestyle.\n\nChoose from our beautifully designed floor plans, featuring modern conveniences such as range appliances, air conditioning, and window coverings. Enjoy community amenities like a fitness center, sparkling pool, and inviting clubhouse, all contributing to a balanced and innovative living experience. Discover why Villas at Stonebridge is the perfect fit for those seeking proximity to Oklahoma Christian University. Visit us today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table set, in front of a grand building with columns.",
        "public_id": "019cfb4c-89b2-7571-8d2f-347d6d3ab2fe",
        "storage_key": "property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Oklahoma Christian University",
      "seo_description": "Find ideal apartments close to Oklahoma Christian University in the 73013 area at Villas at Stonebridge, offering comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "generator",
      "page_item_url": "apartments-near-integris-health-edmond-hospital",
      "search_query": "apartments near INTEGRIS Health Edmond Hospital",
      "category": "Hospital",
      "h1_title": "Apartments Near INTEGRIS Health Edmond Hospital",
      "h2_subtitle": "Discover convenient living near INTEGRIS Health Edmond Hospital with beautiful apartments at Villas at Stonebridge.",
      "page_copy": "For those seeking apartments near INTEGRIS Health Edmond Hospital, Villas at Stonebridge provides the perfect solution with its prime location and exceptional amenities. Whether you're a healthcare professional or someone who values proximity to medical facilities, our community ensures ease and comfort.\n\nOur stylish one, two, and three-bedroom apartments are equipped with modern amenities like air conditioning, range appliances, and spacious patios. The community features a sparkling pool, pet play area, and fitness center, catering to all aspects of your lifestyle. Experience the blend of convenience and luxury at Villas at Stonebridge, ideal for anyone seeking apartments near INTEGRIS Health Edmond Hospital. Schedule your tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table set, in front of a grand building with columns.",
        "public_id": "019cfb4c-89b2-7571-8d2f-347d6d3ab2fe",
        "storage_key": "property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near INTEGRIS Health Edmond Hospital",
      "seo_description": "Find perfect living solutions at Villas at Stonebridge, offering apartments near INTEGRIS Health Edmond Hospital with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "generator",
      "page_item_url": "edmond-ok-apartments-close-mcbride-orthopedic-hospital",
      "search_query": "Edmond OK apartments close to McBride Orthopedic Hospital",
      "category": "Hospital",
      "h1_title": "Edmond Apartments Near McBride Orthopedic Hospital",
      "h2_subtitle": "Explore Edmond, OK apartments close to McBride Orthopedic Hospital at Villas at Stonebridge, perfect for healthcare professionals.",
      "page_copy": "If you're looking for Edmond, OK apartments close to McBride Orthopedic Hospital, Villas at Stonebridge offers an unbeatable location coupled with premium amenities. Our community is ideal for healthcare professionals and those who appreciate being close to essential medical services.\n\nChoose from our range of one, two, and three-bedroom floor plans, all designed with modern conveniences such as air conditioning and range appliances. Benefit from our community amenities, including a pet play area, fitness center, and a sparkling pool. At Villas at Stonebridge, you’ll find both comfort and convenience, making it the perfect choice for those wanting proximity to McBride Orthopedic Hospital. Visit us today and find your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table set, in front of a grand building with columns.",
        "public_id": "019cfb4c-89b2-7571-8d2f-347d6d3ab2fe",
        "storage_key": "property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Edmond Apartments Near McBride Orthopedic Hospital",
      "seo_description": "Discover Villas at Stonebridge, offering Edmond, OK apartments close to McBride Orthopedic Hospital with modern amenities and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "generator",
      "page_item_url": "villas-stonebridge-near-e-c-hafer-park-edmond",
      "search_query": "villas at stonebridge near e.c. hafer park edmond",
      "category": "Park",
      "h1_title": "Villas at Stonebridge Near E.C. Hafer Park",
      "h2_subtitle": "Experience the ideal lifestyle at Villas at Stonebridge near E.C. Hafer Park in Edmond, perfect for nature lovers and families.",
      "page_copy": "Nestled near E.C. Hafer Park in Edmond, Villas at Stonebridge offers residents the benefits of tranquil surroundings combined with the comforts of modern living. Our community is perfect for those who enjoy outdoor activities, as E.C. Hafer Park is just a short distance away, providing a serene escape.\n\nAt Villas at Stonebridge, choose from spacious one, two, and three-bedroom apartments featuring top-notch amenities like air conditioning and range appliances. Our community also boasts a sparkling pool, pet play area, and an inviting clubhouse, making it an ideal choice for families and nature enthusiasts. Experience the perfect balance of nature and luxury by making Villas at Stonebridge your home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table set, in front of a grand building with columns.",
        "public_id": "019cfb4c-89b2-7571-8d2f-347d6d3ab2fe",
        "storage_key": "property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Villas at Stonebridge Near E.C. Hafer Park",
      "seo_description": "Find modern living at Villas at Stonebridge near E.C. Hafer Park, Edmond. Enjoy great amenities and the beauty of nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165641",
      "source": "generator",
      "page_item_url": "apartments-close-to-mitch-park-oklahoma",
      "search_query": "apartments close to mitch park oklahoma",
      "category": "Park",
      "h1_title": "Apartments Close to Mitch Park, Oklahoma",
      "h2_subtitle": "Discover the ease of living in apartments close to Mitch Park, Oklahoma, at Villas at Stonebridge where comfort meets convenience.",
      "page_copy": "For those searching for apartments close to Mitch Park, Oklahoma, Villas at Stonebridge presents an ideal living opportunity. This community combines the convenience of modern amenities with the beauty of nearby Mitch Park, catering perfectly to outdoor enthusiasts and active families.\n\nOur one, two, and three-bedroom apartments are designed for comfort, featuring air conditioning, range appliances, and spacious patios. Just a short drive to Mitch Park, our community also offers a pet play area, fitness center, and a refreshing pool. Experience the best of both worlds at Villas at Stonebridge, where proximity to nature and luxury apartment living go hand in hand. Schedule your visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a table set, in front of a grand building with columns.",
        "public_id": "019cfb4c-89b2-7571-8d2f-347d6d3ab2fe",
        "storage_key": "property/6767906449165641/019cfb4c-89b2-7571-8d2f-347d6d3ab2fe.webp",
        "width": 1240,
        "height": 828
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mitch Park, Oklahoma",
      "seo_description": "Explore Villas at Stonebridge, offering comfortable apartments close to Mitch Park in Oklahoma with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5226"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-J0FWKMRJY5"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151491"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/villas-stonebridge/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MKKLLF7R"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165641/019d1bda-cc2c-7678-a3ed-7623fb91ed4b.pdf"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "877-707-0942"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "67c6aeaacde1fc860e83dcd7"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkROWDl3VS96VngyandjL1VENTFhaXc9PSIsInZhbHVlIjoiRC9OM0VCZzFlVDFUN2tnSHZKWjYrUT09IiwibWFjIjoiYmVmZDU3ODEyYWI2ZGQwOGMyYTUzZjFiYWU4M2ZiMDMzNzIzMzAwNzlhOWY4YTY5MWU0YWViZGRjMmIwMDVkZCJ9"
    }
  ],
  "custom_qb_id": "5226",
  "custom_ga4_id": "G-J0FWKMRJY5",
  "custom_repli_id": "10041151491",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/villas-stonebridge/register/",
  "custom_google_gtm_id": "GTM-MKKLLF7R",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165641/019d1bda-cc2c-7678-a3ed-7623fb91ed4b.pdf",
  "custom_ppc_tracking_phone_number": "877-707-0942",
  "custom_residentboost_apartment_id": "67c6aeaacde1fc860e83dcd7",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkROWDl3VS96VngyandjL1VENTFhaXc9PSIsInZhbHVlIjoiRC9OM0VCZzFlVDFUN2tnSHZKWjYrUT09IiwibWFjIjoiYmVmZDU3ODEyYWI2ZGQwOGMyYTUzZjFiYWU4M2ZiMDMzNzIzMzAwNzlhOWY4YTY5MWU0YWViZGRjMmIwMDVkZCJ9"
};

export const generatedAt = '2026-08-27T21:35:08.013Z';
